// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul,
li {
  list-style: none;
  padding: 0px;
  margin: 0px;
}
.left {
  float: left;
}
.right {
  float: right;
}
.clear-fix:after {
  content: " ";
  display: block;
  clear: both;
  float: none;
}
.btn + .btn {
  margin: 0 !important;
}
p {
  word-break: break-word;
}
.full-height {
  height: 100%;
}
img {
  max-width: 100%;
}
.favourite-icon {
  cursor: pointer;
}
.favourite-participant-icon {
  cursor: pointer;
  display: inline-block;
  text-align: center;
  padding: 6px 8px;
  width: 100%;
}
@media only screen and (min-width: 1200px) {
  .favourite-participant-icon {
    padding: 3px;
    width: 300px;
    float: right;
  }
}
@media only screen and (min-width: 1025px) and (max-width: 1199px) {
  .favourite-participant-icon {
    padding: 3px;
    width: 250px;
    float: right;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .favourite-participant-icon {
    padding: 3px;
    width: 200px;
    float: right;
  }
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .favourite-participant-icon {
    padding: 8px;
    max-width: fit-content;
  }
}
@media (max-width: 767px) {
  .favourite-participant-icon {
    display: block;
  }
}
@media only screen and (min-width: 1025px) {
  .favourite-icon-container {
    padding-left: 10px;
  }
}
.favourite-icon-img {
  vertical-align: middle;
  margin-right: 2.5px;
  margin-left: 2.5px;
}
.favourite-icon-label {
  padding-left: 8px;
}
.favourite-unselect-fill-opacity {
  fill-opacity: 0;
}
.directory-favourite-icon {
  display: inline-flex;
}
.label.label-in-list {
  display: inline-block;
  word-break: break-word;
  white-space: normal;
  margin: 0.2rem 0.8rem 0.2rem 0;
  color: #2d2d2d;
}
.participant-profile-container .feature-filter-label-list {
  display: inline-block;
}
.participant-profile-container .feature-filter-label-list div {
  float: left;
  margin-right: 10px;
}
.participant-profile-container .feature-filter-label-list .feature-filter-label {
  border: solid 2px #dddddd;
  display: inline-block;
  background-color: var(--white);
  height: auto;
  padding: 2.4px 10px;
  margin-top: 0.8rem;
  border-radius: 10px;
  color: #2d2d2d;
  font-family: Roboto, sans-serif;
  font-weight: bold;
  font-size: 9px;
  text-transform: uppercase;
  line-height: normal;
  word-break: break-word;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
@media (max-width: 768px) {
  .participant-profile-container .feature-filter-label-list div {
    height: 40px;
  }
}
.network-participant-icon {
  cursor: pointer;
  display: inline-block;
  text-align: center;
  padding: 3px 8px;
  width: 100%;
}
@media only screen and (min-width: 1200px) {
  .network-participant-icon {
    padding: 3px;
    width: 300px;
    float: right;
  }
}
@media only screen and (min-width: 1025px) and (max-width: 1199px) {
  .network-participant-icon {
    padding: 3px;
    width: 250px;
    float: right;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .network-participant-icon {
    padding: 3px;
    width: 200px;
    float: right;
  }
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .network-participant-icon {
    padding: 8px;
    max-width: fit-content;
  }
}
@media (max-width: 767px) {
  .network-participant-icon {
    display: block;
  }
}
.network-icon-container {
  width: 100%;
}
@media only screen and (min-width: 1025px) {
  .network-icon-container {
    padding-left: 10px;
  }
}
.network-icon-container .right {
  display: flex;
  flex-direction: column;
  width: 390px;
}
.network-icon-container .text-danger {
  font-size: 80%;
  margin-top: 5px;
}
.chat-icon-container {
  width: 100%;
}
@media only screen and (min-width: 1025px) {
  .chat-icon-container {
    padding-left: 10px;
  }
}
.chat-icon-container .right {
  display: flex;
  flex-direction: column;
  width: 390px;
}
.chat-icon-container .text-danger {
  font-size: 80%;
  margin-top: 5px;
}
.chat-participant-div {
  cursor: pointer;
  display: inline-block;
  text-align: center;
  padding: 6px 8px;
  width: 100%;
}
@media only screen and (min-width: 1200px) {
  .chat-participant-div {
    padding: 3px;
    width: 300px;
    float: right;
  }
}
@media only screen and (min-width: 1025px) and (max-width: 1199px) {
  .chat-participant-div {
    padding: 3px;
    width: 250px;
    float: right;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .chat-participant-div {
    padding: 3px;
    width: 200px;
    float: right;
  }
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .chat-participant-div {
    padding: 8px;
    max-width: fit-content;
  }
}
@media (max-width: 767px) {
  .chat-participant-div {
    display: block;
  }
}
@media only screen and (min-width: 768px) {
  .mobile-view-icon {
    display: none;
  }
}
@media only screen and (max-width: 767px) {
  .mobile-view-icon {
    display: inline-block;
  }
}
@media only screen and (min-width: 768px) {
  .desktop-view-icon {
    display: inline-block;
  }
}
@media only screen and (max-width: 767px) {
  .desktop-view-icon {
    display: none;
  }
}
.network-digital-portfolio-name-container {
  display: block;
  align-items: baseline;
  justify-content: center;
  text-align: center;
  vertical-align: middle;
  padding-top: 15px;
}
.network-digital-portfolio-name {
  font-size: 80%;
  padding: 2px 0 0 2px;
}
.icon-container {
  display: flex;
  flex-direction: column;
  flex: auto;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .icon-container {
    max-width: fit-content;
  }
}
.network-icon-profile {
  cursor: pointer;
  display: inline-block;
  text-align: center;
  width: 390px;
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .network-icon-profile {
    padding: 7.5px 8px;
    margin-left: 120px;
    margin-top: 8px;
  }
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .network-icon-profile {
    padding: 8px;
  }
}
@media (max-width: 767px) {
  .network-icon-profile {
    display: block;
  }
}
@media (max-width: 450px) {
  .custom-overlay-tooltip {
    margin-left: 55px;
  }
}
@media (min-width: 451px) {
  .custom-overlay-tooltip {
    margin-left: 53px;
  }
}
.new-line {
  white-space: pre-line;
}
.error-message-link {
  color: #a94442;
  font-weight: bold;
  margin-left: 3px;
}
.profile-image-error {
  display: flex;
  align-items: baseline;
  gap: 1rem;
}
.underline {
  text-decoration: underline;
}
.image-container-highlight {
  border: solid #E26363 2px;
}
.participant-banner-highlight {
  border: solid #E7B810 2px;
  border-radius: 10px;
  padding: 15px;
}
.participant-banner-highlight-text {
  color: #995E00;
  font-weight: 600;
  cursor: pointer;
  font-size: 20px;
  margin-top: 10px;
}
@media (max-width: 991px) {
  .participant-banner-highlight-text {
    text-align: center;
  }
}
[data-testid="Copy-Component"]:focus {
  outline: 2px solid #337ab7;
  outline-offset: 2px;
  border-radius: 3px;
}
[data-testid="Copy-Component"]:focus:not(:focus-visible) {
  outline: none;
}
[data-testid="Copy-Component"]:focus-visible {
  outline: 2px solid #337ab7;
  outline-offset: 2px;
  border-radius: 3px;
}
.with-opacity {
  opacity: 0.3;
}
.facebook-logo {
  fill: #3b5998;
}
.facebook-logo-color {
  fill: #4267b2;
}
.twitter-logo-color {
  fill: #1da1f2;
}
.youtube-logo-color {
  fill: #fc0d1c;
}
.linkedin-logo-color {
  fill: #0077b5;
}
.wechat-logo-color {
  fill: #51c332;
}
.activation-email {
  text-align: right;
}
.activation-email-collapse {
  text-align: left;
}
.btn + .btn.activation-email-button {
  margin-left: 0.8rem !important;
}
.resend-email-button {
  background-color: #ffffff;
  border: solid 1px #a2a2a2;
  color: #337ab7;
  font-size: 14px;
}
.resend-email-button i {
  font-size: 18px;
}
.resend-email-button:hover {
  background-color: #e2e6ea;
}
.social-media-logo-container {
  margin-top: 1.5rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.social-media-logo-container .social-media-logo {
  display: inline-block;
  width: calc(100% * (1/3));
  margin-bottom: 2em;
}
@media (max-width: 992px) and (min-width: 768px) {
  .social-media-logo-container .social-media-logo {
    width: calc(100% * (1/6));
  }
}
.relative,
.editable-container {
  position: relative;
}
.border {
  border: 1px solid #dddddd;
}
.darkBorder {
  border: 1px solid #dddddd;
  border-color: #dddddd;
}
.darkBorderBottom {
  border-bottom: 1px solid #dddddd;
}
.darkBorderTop {
  border-top: 1px solid #dddddd;
}
.h2 {
  margin-bottom: 0.5em;
}
.multilineOverflow {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.singleLineOverflow {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.twoLinesOverflow {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.threeLinesOverflow {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.fourLinesOverflow {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}
.verticalMiddle {
  display: inline-block;
  vertical-align: middle;
}
.verticalTop {
  display: inline-block;
  vertical-align: top;
}
.algolia-error {
  display: block;
  padding: 2em;
  background: #fbeddc;
  text-align: center;
  color: #FF0000;
}
.submitting {
  opacity: 0.6;
}
[type='file']::-webkit-file-upload-button {
  -webkit-appearance: button;
}
.absolute-stretch {
  display: block;
  position: absolute;
  top: 0px;
  left: 0;
  bottom: 0px;
  right: 0px;
}
.absolute-vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.tag-list.participants {
  padding: 0px;
  margin: 0px;
}
.tag-list.participants > li {
  display: inline-block;
  vertical-align: top;
  padding: 0px 10px;
  background: #dddddd;
  margin-right: 10px;
  margin-bottom: 10px;
  border: 1px solid #dddddd;
  border-color: #dddddd;
}
.file-upload {
  overflow: hidden;
}
.file-upload .file-upload-wrapper {
  position: relative;
}
.file-upload .file-upload-wrapper .fa,
.file-upload .file-upload-wrapper .fa-solid,
.file-upload .file-upload-wrapper .fa-regular,
.file-upload .file-upload-wrapper .fa-light,
.file-upload .file-upload-wrapper .fa-brands {
  padding: 8px 7px;
  cursor: pointer;
}
.file-upload .file-upload-wrapper input[type='file'] {
  display: none;
}
.file-upload .file-upload-wrapper .fa-camera,
.file-upload .file-upload-wrapper .fa-upload {
  vertical-align: top;
  font-size: 2.4rem;
}
.profile-image .image-container.editable {
  position: relative;
}
.profile-image .file-upload {
  position: absolute;
  right: 2px;
  bottom: 14px;
  top: auto;
  font-size: 2.5rem;
  color: white;
  border-radius: 3px;
}
.profile-image .spinner {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  margin: 0px;
  background: none;
  border: none;
}
.stretchable-spinner {
  display: block;
  position: absolute;
  top: 0px;
  left: 0;
  bottom: 0px;
  right: 0px;
  background: rgba(255, 255, 255, 0.3);
  border: 1px solid gray;
}
.stretchable-spinner .spinner {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  margin: 0px;
  background: none;
  border: none;
}
.logged-in-user-settings {
  text-align: center;
  margin-bottom: 15px;
  padding: 20px 20px 20px 20px;
}
.logged-in-user-settings > li {
  display: inline-block;
  vertical-align: top;
  cursor: pointer;
  padding: 0 0.7em;
}
.logged-in-user-settings > li nav,
.logged-in-user-settings > li a {
  display: block;
  min-height: auto;
}
.logged-in-user-settings > li,
.logged-in-user-settings > li a,
.logged-in-user-settings > li span {
  color: inherit;
}
.logged-in-user-settings > li span {
  display: inline-block;
  vertical-align: middle;
  font-size: 2rem;
  font-weight: 400;
}
@media (max-width: 768px) {
  .logged-in-user-settings {
    text-align: left;
  }
  .logged-in-user-settings > li {
    display: block;
    padding: 0.7em;
    color: inherit;
  }
}
.settings-navbar-list .logged-in-user-settings__base {
  position: relative;
  width: 100%;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  flex-wrap: wrap;
}
.settings-navbar-list .logged-in-user-settings__welcome {
  display: block;
  font-size: 25px;
}
@media (min-width: 768px) {
  .settings-navbar-list .logged-in-user-settings__welcome {
    flex-grow: 2;
    width: auto;
  }
}
.settings-navbar-list .logged-in-user-settings__list {
  list-style: none;
  padding-left: 0;
  padding-right: 0;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}
@media (min-width: 768px) {
  .settings-navbar-list .logged-in-user-settings__list {
    width: auto;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
}
.settings-navbar-list .logged-in-user-settings__item {
  padding-left: 10px;
}
.settings-navbar-list .logged-in-user-settings__item:not(:last-child):after {
  content: "";
  border-right: 1px solid gray;
}
@media (min-width: 768px) {
  .settings-navbar-list .logged-in-user-settings__item:last-child:after {
    content: "";
    border-right: 1px solid gray;
  }
}
.settings-navbar-list .logged-in-user-settings__link {
  white-space: nowrap;
  font-size: 15px;
}
.settings-navbar-list .logged-in-user-settings__link--logout {
  padding-left: 10px;
}
@media (min-width: 768px) {
  .settings-navbar-list .logged-in-user-settings__link--logout {
    order: 3;
  }
}
.settings-navbar-list .logged-in-user-settings__label {
  padding-left: 10px;
  padding-right: 10px;
}
.settings-dropdown {
  position: relative;
}
.settings-dropdown .logged-in-user-settings__dropdown-base {
  position: absolute;
  z-index: 1;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 250px;
}
@media (max-width: 480px) {
  .settings-dropdown .logged-in-user-settings__dropdown-base {
    width: 100%;
    position: relative;
  }
}
.settings-dropdown .logged-in-user-settings__dropdown-list {
  list-style: none;
  padding-left: 0;
  padding-right: 0;
  width: 250px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-end;
  color: white;
  border-radius: 0 0 4px 4px;
}
.settings-dropdown .logged-in-user-settings__dropdown-list__hide {
  display: none;
}
@media (min-width: 768px) {
  .settings-dropdown .logged-in-user-settings__dropdown-list {
    width: auto;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
}
@media (max-width: 480px) {
  .settings-dropdown .logged-in-user-settings__dropdown-list {
    width: 100%;
    border-radius: 0;
  }
}
.settings-dropdown .logged-in-user-settings__dropdown-item {
  padding-left: 15px;
  width: 250px;
  margin-bottom: 10px;
}
.settings-dropdown .logged-in-user-settings__dropdown-item:first-child {
  margin-top: 15px;
}
.settings-dropdown .logged-in-user-settings__dropdown-item:not(:last-child):after {
  content: '';
  display: block;
  border-bottom: 1px solid white;
  width: 220px;
  height: 1px;
  margin-top: 10px;
}
@media (max-width: 480px) {
  .settings-dropdown .logged-in-user-settings__dropdown-item:not(:last-child):after {
    width: 95%;
  }
}
.settings-dropdown .logged-in-user-settings__dropdown-item span {
  color: white;
}
@media (min-width: 768px) {
  .settings-dropdown .logged-in-user-settings__dropdown-item:last-child:after {
    content: "";
  }
}
@media (max-width: 480px) {
  .settings-dropdown .logged-in-user-settings__dropdown-item {
    width: 100%;
  }
}
.settings-dropdown .logged-in-user-settings__dropdown-link {
  white-space: nowrap;
  font-size: 15px;
}
.settings-dropdown .logged-in-user-settings__dropdown-link--logout {
  padding-left: 0px;
}
@media (min-width: 768px) {
  .settings-dropdown .logged-in-user-settings__dropdown-link--logout {
    order: 3;
  }
}
.settings-dropdown .logged-in-user-settings__dropdown-label {
  padding-left: 10px;
  padding-right: 10px;
  color: white;
}
.participant-dropdown-image img {
  border: 1px solid #dddddd;
  border-radius: 180px;
  width: 30px;
  height: 30px;
  max-width: 30px !important;
}
.participant-dropdown-text {
  color: white;
  width: 100%;
  height: 18px;
  margin: 6.5px 35.5px 5.5px 10px;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (min-width: 768px) {
  .participant-dropdown-text {
    flex-grow: 2;
    width: auto;
  }
}
.participant-dropdown-container {
  display: flex;
  flex-direction: row;
  width: 250px;
  height: 43px;
  padding: 5px 10.5px 10px 15px;
  object-fit: contain;
  border-radius: 4px 4px 4px 4px;
  position: relative;
  cursor: pointer;
}
@media (max-width: 480px) {
  .participant-dropdown-container {
    width: 100%;
    border-radius: 0;
  }
}
.top-round-border {
  border-radius: 4px 4px 0 0;
}
.down-arrow-settings-dropdown {
  position: absolute;
  color: white;
  display: flex;
  height: 100%;
  right: 26px;
  top: 0px;
}
.down-arrow-settings-dropdown:after {
  content: "\\f107";
  position: absolute;
  display: flex;
  font-family: "Font Awesome 7 Free", sans-serif;
  font-weight: 900;
  height: 100%;
  font-size: 2.5rem;
  align-self: center;
}
.up-arrow-settings-dropdown {
  position: absolute;
  color: white;
  display: flex;
  height: 100%;
  right: 26px;
  top: 0px;
}
.up-arrow-settings-dropdown:after {
  content: "\\f106";
  position: absolute;
  display: flex;
  font-family: "Font Awesome 7 Free", sans-serif;
  font-weight: 900;
  height: 100%;
  font-size: 2.5rem;
  align-self: center;
}
.online-directory {
  text-align: left;
  font-size: 2.8rem;
}
.online-directory > li,
.online-directory > li a,
.online-directory > li span {
  text-transform: capitalize;
}
.edit-icon {
  position: absolute;
  right: 0px;
  top: 0px;
  height: 40px;
  width: 40px;
  padding: 7px;
  font-size: 2.4rem;
  cursor: pointer;
}
.edit-icon .fa-lg {
  padding: 0.3em 0;
}
.edit-icon i {
  font-size: 2.4rem;
  vertical-align: top;
}
.editable-description {
  position: relative;
  word-break: break-word;
}
.profile-header {
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  width: 36.4rem;
  padding: 1rem;
  float: left;
}
.profile-header label {
  display: block;
  padding-bottom: 1rem;
  font-size: 1.8rem;
  line-height: normal;
  text-transform: none;
}
.show-more-less input[type='checkbox'] {
  display: none;
}
.show-more-less .content {
  overflow: hidden;
  max-height: 100px;
  position: relative;
  line-height: 2rem;
  word-break: break-word;
}
.show-more-less label {
  background: #FFFFFF;
  text-transform: lowercase;
}
.show-more-less label#show_more {
  display: inline-block;
  cursor: pointer;
  position: absolute;
  top: 80px;
  right: 0px;
  left: 0px;
}
.show-more-less label#show_less {
  display: block;
  cursor: pointer;
  position: absolute;
  top: 100%;
  right: 0px;
  left: 0px;
}
.show-more-less input[type='checkbox'] ~ .content label#show_more {
  display: block;
}
.show-more-less input[type='checkbox'] ~ .content label#show_less {
  display: none;
}
.show-more-less input[type='checkbox']:checked ~ .content label#show_more {
  display: none;
}
.show-more-less input[type='checkbox']:checked ~ .content label#show_less {
  display: block;
}
.show-more-less input[type='checkbox']:checked ~ .content {
  max-height: initial;
  overflow: visible;
}
.block-with-text {
  overflow: hidden;
  position: relative;
  line-height: 1.2em;
  max-height: 3.6em;
  text-align: justify;
  margin-right: -1em;
  padding-right: 1em;
}
.block-with-text:before {
  content: '...';
  position: absolute;
  right: 0;
  bottom: 0;
}
.block-with-text:after {
  content: '';
  position: absolute;
  right: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.2em;
  background: white;
}
.logged-in-user-spinner {
  padding: 5px;
  max-width: 50%;
}
.participant-contact-form {
  position: relative;
  padding: 1.5rem;
}
.participant-contact-form > .form-row {
  margin: 2.5rem 0px;
}
.participant-contact-form > .form-row > label {
  margin: 5px 0px;
}
.participant-contact-form > .form-row .icon-container {
  padding: 5px 0px;
}
.participant-contact-form > .form-row .icon-container svg,
.participant-contact-form > .form-row .icon-container label {
  display: inline-block;
  vertical-align: middle;
}
.participant-contact-form > .form-row .icon-container label {
  margin-left: 8px;
}
.participant-contact-form > .form-row input {
  width: 100%;
}
.stand {
  display: inline;
}
.stand .fa,
.stand .fa-solid,
.stand .fa-regular,
.stand .fa-light,
.stand .fa-brands {
  font-size: 2rem;
}
.stand span {
  margin-right: 5px;
}
.stand .stand-name:not(:last-child):after {
  content: ",";
}
.search-bar {
  border: 1px solid #dddddd;
  border-color: #dddddd;
}
.search-bar .input-container {
  margin-right: 67px;
}
.search-bar .input-container input {
  width: 100%;
  display: block;
  border: none;
  padding: 9px 10px;
}
.search-bar button {
  float: right;
  margin: 0px;
}
.search-bar button i {
  font-size: 2.5rem;
}
.profile-image .image-container {
  position: relative;
  width: 180px;
  height: 180px;
  background: #d9d9d9;
  border-radius: 180px;
  overflow: hidden;
}
.profile-image .image-container img {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.switch {
  position: relative;
  display: inline-block;
  width: 140px;
  height: 34px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.switch input:checked + .slider {
  background-color: #2196F3;
}
.switch input:checked + .slider:before {
  margin-left: calc(100% - 36px);
}
.switch input:checked + .slider .message {
  left: 10px;
  right: auto;
  color: white;
}
.switch input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}
.switch .slider {
  z-index: 1;
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  width: 140px;
  /* Rounded sliders */
}
.switch .slider .message {
  position: absolute;
  top: 5px;
  left: 36px;
  right: auto;
}
.switch .slider.round {
  border-radius: 34px;
}
.switch .slider.round:before {
  border-radius: 50%;
}
.switch .slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.image-help-text {
  margin: auto;
  margin-top: 43px;
  margin-left: 19px;
  font-size: 1.2rem;
  color: #808080;
}
.image-help-text .icon-container span,
.image-help-text .icon-container i {
  display: inline-block;
  vertical-align: middle;
}
.image-help-text .icon-container i.fa,
.image-help-text .icon-container i.fa-solid,
.image-help-text .icon-container i.fa-regular,
.image-help-text .icon-container i.fa-light,
.image-help-text .icon-container i.fa-brands {
  font-size: 24pt;
  margin-bottom: 0.5rem;
  position: static;
  width: auto;
  color: #2d2d2d;
}
.image-help-text .icon-container span {
  width: calc(100% - 40px);
  margin-left: 0.5rem;
  color: #2d2d2d;
  font-weight: 700;
  font-size: 1.5rem;
}
.empty-content {
  min-height: 10rem;
  border: dashed thin #404040;
  padding: 10px;
  margin-top: 4rem;
}
.form-field-switch-group {
  margin-bottom: 20px;
}
.spinner-wrapper {
  position: absolute;
  width: 22px;
  height: 22px;
  top: 50%;
  left: 50%;
  margin-top: -11px;
  margin-left: -11px;
}
.spinner-wrapper_big {
  width: 80px;
  height: 80px;
  top: 50%;
  left: 50%;
  margin-top: -80px / 2;
  margin-left: -80px / 2;
}
.spinner-wrapper_big .circle-wrapper {
  width: 80px;
  height: 80px;
}
.spinner-wrapper_fixed {
  position: fixed;
}
.circle-wrapper {
  width: 22px;
  height: 22px;
  position: relative;
}
.circle {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.circle:before {
  content: '';
  display: block;
  margin: 0 auto;
  width: 20%;
  height: 20%;
  border-radius: 100%;
  -webkit-animation: bouncedelay 1.2s infinite ease-in-out;
  animation: bouncedelay 1.2s infinite ease-in-out;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.circle2 {
  -webkit-transform: rotate(30deg);
  transform: rotate(30deg);
}
.circle3 {
  -webkit-transform: rotate(60deg);
  transform: rotate(60deg);
}
.circle4 {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}
.circle5 {
  -webkit-transform: rotate(120deg);
  transform: rotate(120deg);
}
.circle6 {
  -webkit-transform: rotate(150deg);
  transform: rotate(150deg);
}
.circle7 {
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
.circle8 {
  -webkit-transform: rotate(210deg);
  transform: rotate(210deg);
}
.circle9 {
  -webkit-transform: rotate(240deg);
  transform: rotate(240deg);
}
.circle10 {
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
}
.circle11 {
  -webkit-transform: rotate(300deg);
  transform: rotate(300deg);
}
.circle12 {
  -webkit-transform: rotate(330deg);
  transform: rotate(330deg);
}
.circle2:before {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}
.circle3:before {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}
.circle4:before {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}
.circle5:before {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}
.circle6:before {
  -webkit-animation-delay: -0.7s;
  animation-delay: -0.7s;
}
.circle7:before {
  -webkit-animation-delay: -0.6s;
  animation-delay: -0.6s;
}
.circle8:before {
  -webkit-animation-delay: -0.5s;
  animation-delay: -0.5s;
}
.circle9:before {
  -webkit-animation-delay: -0.4s;
  animation-delay: -0.4s;
}
.circle10:before {
  -webkit-animation-delay: -0.3s;
  animation-delay: -0.3s;
}
.circle11:before {
  -webkit-animation-delay: -0.2s;
  animation-delay: -0.2s;
}
.circle12:before {
  -webkit-animation-delay: -0.1s;
  animation-delay: -0.1s;
}
@-webkit-keyframes bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}
@keyframes bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
.spinner {
  width: 100%;
  height: auto;
  padding: 10px;
  margin: auto;
  text-align: center;
  margin-bottom: 20px;
  background: #EAEAEA;
  border: 1px solid #dddddd;
  border-color: #dddddd;
}
.spinner .circle-wrapper,
.spinner .spinner-wrapper {
  width: 30px;
  height: 30px;
  text-align: left;
  display: inline-block;
  vertical-align: middle;
}
.spinner .spinner-wrapper {
  position: relative;
  left: auto;
  top: auto;
  margin: 0px 10px 0px 0px;
}
.spinner.big-spinner {
  width: 200px;
}
.spinner.big-spinner .circle-wrapper,
.spinner.big-spinner .spinner-wrapper {
  width: 80px;
  height: 80px;
  display: block;
  margin: auto;
}
.hierachical-filter {
  border: 1px solid #dddddd;
  border-color: #dddddd;
  border-radius: 0px;
}
.hierachical-filter > ul > li > .header {
  border-bottom: 1px solid #dddddd;
  border-radius: 0px;
}
.hierachical-filter > ul > li:last-child > .header:not(.highlight) {
  border-bottom: none;
}
.hierachical-filter ul > li .highlight {
  border-bottom: 1px solid #dddddd;
  border-radius: 0px;
}
.hierachical-filter ul > li.is-opened {
  border-bottom: 1px solid #dddddd;
  border-radius: 0px;
}
.hierachical-filter ul > li.is-opened .header:not(.highlight) {
  border-bottom: none;
}
.hierachical-filter ul > li.current-selected > .header:after,
.hierachical-filter ul > li.is-opened > .header:after {
  content: "";
  width: 20px;
  height: 20px;
  background: lightcoral;
  position: absolute;
  right: 20px;
  top: 20px;
}
.hierachical-filter ul li .header {
  position: relative;
  padding: 13px 20px;
  cursor: pointer;
}
.hierachical-filter ul li .header.highlight {
  position: relative;
  padding: 5px 20px;
}
.hierachical-filter ul li .header.highlight .highlighter {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  width: 8px;
}
.hierachical-filter ul li.multiselectable,
.hierachical-filter ul li .multiselectable {
  position: relative;
  padding: 5px 20px;
  margin-left: 20px;
}
.hierachical-filter ul li.multiselectable,
.hierachical-filter ul li .multiselectable,
.hierachical-filter ul li.multiselectable input,
.hierachical-filter ul li .multiselectable input,
.hierachical-filter ul li.multiselectable label,
.hierachical-filter ul li .multiselectable label,
.hierachical-filter ul li.multiselectable .duplicate-checkbox,
.hierachical-filter ul li .multiselectable .duplicate-checkbox {
  cursor: pointer;
}
.hierachical-filter ul li.multiselectable input[type='checkbox'],
.hierachical-filter ul li .multiselectable input[type='checkbox'] {
  display: none;
}
.hierachical-filter ul li.multiselectable label,
.hierachical-filter ul li .multiselectable label {
  position: relative;
  padding-left: 20px;
  z-index: 1;
  font-size: 1.8rem;
  font-weight: 400;
  line-height: 1.8rem;
  color: #4a4a4a;
}
.hierachical-filter ul li.multiselectable .duplicate-checkbox,
.hierachical-filter ul li .multiselectable .duplicate-checkbox {
  content: " ";
  position: absolute;
  left: 0px;
  top: 4px;
  border: 1px solid #dddddd;
  border-color: #dddddd;
  padding: 12px;
  border-radius: 0px;
  margin-right: 20px;
  z-index: 0;
}
.hierachical-filter ul li .header {
  color: #2d2d2d;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
}
.hierachical-filter ul li .header .category-name {
  font-size: 1.8rem;
  font-weight: bold;
}
.hierachical-filter ul li .header .selected-items {
  font-size: 1.3rem;
}
.xplore-feedback {
  right: 0;
  bottom: 188px;
  transform-origin: bottom right;
  transform: rotate(-90deg);
  display: block;
  padding: 0;
  position: fixed !important;
  z-index: 9998;
}
.xplore-feedback-button {
  font-size: 14px;
  display: inline-block;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  padding: 10px 20px;
  letter-spacing: normal;
  width: fit-content;
  height: fit-content;
  white-space: nowrap;
  background-color: #2f363f;
  margin-bottom: 0;
}
.survey-feedback-container {
  display: block;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background-color: black;
  background-color: rgba(0, 0, 0, 0.8);
  -webkit-transition: 0.5s;
  transition: all 0.3s linear;
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
}
.survey-feedback-content {
  padding: 12px;
  margin-top: 108px;
  border-radius: 6px;
  background: white;
  z-index: 1;
  margin-left: auto;
  margin-right: auto;
  width: 80%;
  height: 70%;
  position: relative;
  top: 10%;
}
.survey-feedback-close {
  float: right;
  cursor: pointer;
  text-align: center;
  height: 44px;
  width: 44px;
}
.survey-feedback-close-icon {
  font-size: 28px;
  color: grey;
}
.survey-loading-circle {
  top: 50%;
  left: 50%;
  z-index: 999;
  transform: translate(-50%, -50%);
  position: absolute;
}
.survey-spinner-container {
  background: none;
  border: none;
}
.participant-directory {
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
}
.participant-directory h1 {
  margin-bottom: 0.5em;
  text-align: center;
}
.participant-directory .infinite-scroll-component {
  width: 100%;
  display: block;
}
.participant-directory .list-container .big-spinner {
  margin-top: 4em;
}
.participant-directory .email-activation h4 {
  background: none;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  display: inline;
  color: #337ab7;
}
.participant-directory .confirmation-text p {
  margin-right: 350px;
  margin-left: 350px;
}
.participant-directory .confirmation-text strong {
  font-size: 1.9rem;
}
.participant-directory button#email-activation-toggle {
  height: 24px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #0065bc;
  border: none;
  background: none;
  padding: 2px 0 0 0px;
}
.participant-directory button#email-activation-toggle:hover,
.participant-directory button#email-activation-toggle:active,
.participant-directory button#email-activation-toggle:focus {
  outline: white;
  box-shadow: none;
  outline-color: #fff;
}
.participant-directory button#email-activation-toggle i {
  position: relative;
  bottom: -2px;
  left: 10px;
}
.participant-directory .email-activation-text p {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #2d2d2d;
}
.participant-directory .padding-zero {
  padding-right: 0;
}
.participant-directory .display-none {
  display: none;
}
.participant-directory .float-right {
  float: right;
}
.participant-directory .send-activation-email-button {
  font-weight: normal;
  margin-bottom: 0.8rem;
  float: left;
}
.participant-directory .hide-contact-details-toggle {
  float: right;
}
.participant-directory .participant_report_donwload_button {
  float: right;
  margin-right: 15px;
  display: block;
}
.participant-directory .participant_report_donwload_button .fa-circle-arrow-down {
  font-weight: 900;
}
.participant-directory .cancel-email-button {
  color: black;
  background: white;
  border: 2px solid #dddddd;
  margin-top: 0.8rem;
}
.participant-directory #email-collapse-text {
  border: 1px solid grey;
  margin: 5px 0 10px 0;
  padding: 10px;
}
.participant-directory .email-activation button {
  background: none;
}
.participant-directory .confirmation-text {
  text-align: center;
  margin: 0 auto;
}
.participant-directory .email-status-text h4 {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.67;
  letter-spacing: normal;
  color: #2d2d2d;
}
.participant-directory .email-status-text {
  margin-bottom: 10px;
}
.participant-directory .result-count {
  display: block;
  padding: 10px;
}
.participant-directory .directory-content > .hierachical-filter,
.participant-directory .directory-content > .ais-InstantSearch__root {
  display: inline-block;
  vertical-align: top;
}
.participant-directory .directory-content > .hierachical-filter {
  width: 285px;
}
.participant-directory .directory-content > .ais-InstantSearch__root {
  width: calc(100% - 285px);
  padding-left: 20px;
}
.participant-directory .admin-email-activation,
.participant-directory .non-admin-email-activation {
  border-top: solid black 1px;
  padding-top: 15px;
}
.participant-directory .non-admin-mercury-email-activation {
  padding-top: 15px;
}
.participant-directory i.fa-solid.fa-triangle-exclamation.fa-fw {
  width: 1.28571429em;
  margin-right: 10px;
}
.participant-directory .alert-warning {
  display: flex;
  align-items: baseline;
  gap: 1rem;
}
.participant-wrapper {
  display: flex;
}
.participant-details-icon-contact-container {
  display: flex;
  flex-direction: column;
  flex: 4 4 0;
}
@media only screen and (min-width: 1025px) {
  .participant-details-icon-contact-container {
    width: calc(100% - 120px);
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .participant-details-icon-contact-container {
    width: calc(100% - 100px);
  }
}
@media (max-width: 767px) {
  .participant-details-icon-contact-container {
    width: calc(100% - 80px);
  }
}
.participant-details-icon-container {
  display: flex;
  max-width: 100%;
}
.participant-date-on {
  font-size: 12px;
  text-align: left;
}
.date-component {
  margin-bottom: 1rem;
  margin-top: 1rem;
  color: #6E6E6E;
}
participant-item .participant-details > a h3 {
  font-size: 24px;
}
@media (min-width: 320px) and (max-width: 767px) {
  participant-item .participant-details > a h3 {
    font-size: 12px;
  }
}
.participant-item {
  border: 1px solid #dddddd;
}
.participant-item .participant-image {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: 120px;
}
@media (min-width: 768px) and (max-width: 991px) {
  .participant-item .participant-image {
    width: 100px;
  }
}
@media (max-width: 767px) {
  .participant-item .participant-image {
    width: 80px;
  }
}
.participant-item .participant-image a img {
  border: 1px solid #dddddd;
  border-radius: 180px;
  width: 120px;
  height: 120px;
  object-fit: cover;
}
@media (min-width: 768px) and (max-width: 991px) {
  .participant-item .participant-image a img {
    width: 100px;
    height: 100px;
  }
}
@media (max-width: 767px) {
  .participant-item .participant-image a img {
    width: 80px;
    height: 80px;
  }
}
.participant-item .participant-details {
  padding-left: 20px;
  padding-right: 15px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex: 4 4 0;
}
.participant-item .participant-details > a {
  display: block;
  font-size: 2.8rem;
  margin-bottom: 5px;
}
.participant-item .participant-details > a h3 {
  font-size: 2.4rem;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  word-break: break-word;
  margin: 0px;
  line-height: 3rem;
}
.participant-item .participant-details .participant-job-title,
.participant-item .participant-details .participant-org,
.participant-item .participant-details .participant-country {
  margin: 0px;
  line-height: 3rem;
  font-size: 1.8rem;
  word-break: break-word;
}
.participant-item .participant-details .participant-job-title {
  font-weight: 700;
  color: #2D2D2D;
  letter-spacing: 0.3px;
  word-break: break-word;
}
.participant-item .participant-details .participant-org {
  color: #2D2D2D;
  font-weight: 500;
  letter-spacing: 0.7px;
}
.participant-item .participant-details .participant-org > span {
  display: block;
  vertical-align: top;
  max-width: 100%;
  word-break: break-word;
}
.participant-item .participant-details .participant-org > span:first-child {
  padding-right: 5px;
}
.participant-item .participant-details .participant-org > span:only-child {
  max-width: 100%;
  padding-right: 0px;
}
.participant-item .participant-details .participant-country {
  font-weight: 400;
  color: #4a4a4a;
}
.participant-item .participant-wrapper .participant-contact-details {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}
.participant-item .participant-wrapper .contact-items .contact-item {
  padding-bottom: 2.5rem;
  display: flex;
  align-items: center;
}
.participant-item .participant-wrapper .contact-items .contact-item .label {
  font-weight: 500;
  line-height: 1.4em;
  padding: 0px;
  text-transform: uppercase;
}
.participant-item .participant-wrapper .contact-items .contact-item.greyed-out,
.participant-item .participant-wrapper .contact-items .contact-item.greyed-out * {
  color: #696969;
}
.participant-item .participant-wrapper .contact-items .contact-item .fa,
.participant-item .participant-wrapper .contact-items .contact-item .fa-solid,
.participant-item .participant-wrapper .contact-items .contact-item .fa-regular,
.participant-item .participant-wrapper .contact-items .contact-item .fa-light,
.participant-item .participant-wrapper .contact-items .contact-item .fa-brands,
.participant-item .participant-wrapper .contact-items .contact-item .value {
  display: inline-block;
  vertical-align: middle;
}
.participant-item .participant-wrapper .contact-items .contact-item a {
  padding-right: 35px;
}
.participant-item .participant-wrapper .contact-items .contact-item .value {
  word-break: break-all;
  width: calc(100% - 60px);
  padding-left: 15px;
  padding-right: 15px;
  line-height: 2rem;
  font-size: 1.6rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
  justify-content: space-evenly;
}
.participant-item .participant-wrapper .contact-items .contact-item .value.colored {
  color: inherit;
}
.participant-item .participant-wrapper .contact-items {
  padding-top: 25px;
  padding-left: 20px;
  max-width: 100%;
  width: fit-content;
  padding-right: 15px;
}
@media (max-width: 767px) {
  .participant-item .participant-wrapper .contact-items {
    padding-left: 0;
    margin-left: 10px;
  }
}
.participant-item .participant-wrapper .contact-items > .contact-item:nth-child(3) {
  padding-bottom: 0px;
}
span.feature-filter-label:hover {
  cursor: pointer;
}
.feature-filter-label-list {
  display: inline-block;
  margin-top: 10px;
  width: fit-content;
  max-width: 120px;
}
@media (min-width: 768px) and (max-width: 991px) {
  .feature-filter-label-list {
    width: fit-content;
    max-width: 100px;
  }
}
@media (max-width: 767px) {
  .feature-filter-label-list {
    width: fit-content;
    max-width: 80px;
  }
}
.feature-filter-label-list div {
  float: left;
  margin-right: 10px;
}
.feature-filter-label-list .feature-filter-label {
  border: solid 2px #dddddd;
  display: inline-block;
  background-color: var(--white);
  height: auto;
  padding: 2.4px 10px;
  margin-top: 0.8rem;
  border-radius: 10px;
  color: #2d2d2d;
  font-family: Roboto, sans-serif;
  font-weight: bold;
  font-size: 9px;
  text-transform: uppercase;
  line-height: normal;
  word-break: break-word;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: fit-content;
  max-width: 120px;
}
@media (min-width: 768px) and (max-width: 991px) {
  .feature-filter-label-list .feature-filter-label {
    width: fit-content;
    max-width: 100px;
  }
}
@media (max-width: 767px) {
  .feature-filter-label-list .feature-filter-label {
    width: fit-content;
    max-width: 80px;
  }
}
.participant-contact-and-tags {
  display: flex;
}
.participant-directory .algolia-component .list-wrapper ul .participant-item,
.participant-list .list-container ul .participant-item {
  padding: 30px;
  margin-bottom: 10px;
}
@media (max-width: 700px) {
  .participant-directory h2 {
    text-align: center;
    margin-left: 0px;
  }
}
@media (max-width: 420px) {
  .participant-item {
    padding: 20px;
  }
  .participant-item .participant-image {
    float: none;
  }
  .participant-item .participant-details {
    margin: 0px 10px 0px 10px;
    padding: 0px;
  }
  .participant-item .participant-details .participant-org > span {
    display: block;
    max-width: 100%;
    overflow: auto;
    white-space: pre-line;
    margin: 0px;
    padding: 0px;
  }
  .participant-item .participant-details .participant-org > span:first-child {
    padding-right: 0px;
  }
  .participant-item .participant-details .hiphen {
    display: none;
  }
}
.algolia-component .algolia-filter h3,
.algolia-component .algolia-filter .content-wrapper,
.algolia-component .algolia-filter .leaves .leaf .duplicate-checkbox,
.algolia-component .algolia-filter .highlevel-filter,
.algolia-component > .custom-search-header .heading-search-sort .search-bar {
  border-color: #dddddd;
}
.algolia-component > .filter-results {
  width: calc(100% - 310px);
  margin-left: 25px;
}
@media (max-width: 1199px) {
  .algolia-component > .filter-results {
    width: calc(100% - 260px);
  }
}
@media (max-width: 991px) {
  .algolia-component > .filter-results {
    width: calc(100% - 205px);
  }
}
@media (max-width: 767px) {
  .participant-directory .algolia-component {
    position: relative;
  }
  .participant-directory .algolia-component .filter-results {
    width: 100%;
    margin-left: 0;
  }
}
.participant-pps-list-wrapper {
  display: block;
  margin: 0;
  margin-bottom: 2rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.participant-pps-list-wrapper a {
  color: #6E6E6E;
}
.about-me-text {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: black;
  font-weight: 400;
}
.about-me-title {
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/styles/common.less","webpack://./src/styles/participant-directory.less","webpack://./src/styles/mixins.less","webpack://./src/styles/spinner.less","webpack://./src/styles/accordian.less","webpack://./src/styles/feedbackButton.less","webpack://./src/styles/surveyPopup.less"],"names":[],"mappings":"AAEA;;EACI,gBAAA;EACA,YAAA;EACA,WAAA;ACAJ;ADEA;EACI,WAAA;ACAJ;ADEA;EACI,YAAA;ACAJ;ADEA;EACI,YAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;ACAJ;ADGA;EACI,oBAAA;ACDJ;ADIA;EACI,sBAAA;ACFJ;ADKA;EACI,YAAA;ACHJ;ADMA;EACI,eAAA;ACJJ;ADOA;EACI,eAAA;ACLJ;ADQA;EACI,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;ACNJ;ADOI;EAAA;IACI,YAAA;IACA,YAAA;IACA,YAAA;ECJN;AACF;ADKI;EAAA;IACI,YAAA;IACA,YAAA;IACA,YAAA;ECFN;AACF;ADGI;EAAA;IACI,YAAA;IACA,YAAA;IACA,YAAA;ECAN;AACF;ADCI;EAAA;IACI,YAAA;IACA,sBAAA;ECEN;AACF;ADDI;EAAA;IACI,cAAA;ECIN;AACF;ADAI;EAAA;IACI,kBAAA;ECGN;AACF;ADAA;EACI,sBAAA;EACA,mBAAA;EACA,kBAAA;ACEJ;ADCA;EACI,iBAAA;ACCJ;ADEA;EACI,eAAA;ACAJ;ADEA;EACI,oBAAA;ACAJ;ADEA;EACI,qBAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;ACAJ;ADEA;EAEQ,qBAAA;ACDR;ADDA;EAIQ,WAAA;EACA,kBAAA;ACAR;ADLA;EAQY,yBAAA;EACA,qBAAA;EACA,8BAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,+BAAA;EACA,iBAAA;EAAmB,cAAA;EACnB,yBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;ACCZ;ADGI;EAAA;IAGQ,YAAA;ECFV;AACF;ADQA;EACI,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;ACNJ;ADOI;EAAA;IACI,YAAA;IACA,YAAA;IACA,YAAA;ECJN;AACF;ADKI;EAAA;IACI,YAAA;IACA,YAAA;IACA,YAAA;ECFN;AACF;ADGI;EAAA;IACI,YAAA;IACA,YAAA;IACA,YAAA;ECAN;AACF;ADCI;EAAA;IACI,YAAA;IACA,sBAAA;ECEN;AACF;ADDI;EAAA;IACI,cAAA;ECIN;AACF;ADDA;EAII,WAAA;ACAJ;ADHI;EAAA;IACI,kBAAA;ECMN;AACF;ADTA;EAMQ,aAAA;EACA,sBAAA;EACA,YAAA;ACMR;ADdA;EAWO,cAAA;EACA,eAAA;ACMP;ADFA;EAII,WAAA;ACCJ;ADJI;EAAA;IACI,kBAAA;ECON;AACF;ADVA;EAMQ,aAAA;EACA,sBAAA;EACA,YAAA;ACOR;ADfA;EAWO,cAAA;EACA,eAAA;ACOP;ADHA;EACI,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;ACKJ;ADJI;EAAA;IACI,YAAA;IACA,YAAA;IACA,YAAA;ECON;AACF;ADNI;EAAA;IACI,YAAA;IACA,YAAA;IACA,YAAA;ECSN;AACF;ADRI;EAAA;IACI,YAAA;IACA,YAAA;IACA,YAAA;ECWN;AACF;ADVI;EAAA;IACI,YAAA;IACA,sBAAA;ECaN;AACF;ADZI;EAAA;IACI,cAAA;ECeN;AACF;ADXI;EAAA;IACI,aAAA;ECcN;AACF;ADbI;EAAA;IACI,qBAAA;ECgBN;AACF;ADZI;EAAA;IACI,qBAAA;ECeN;AACF;ADdI;EAAA;IACI,aAAA;ECiBN;AACF;ADdA;EACI,cAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;ACgBJ;ADbA;EACI,cAAA;EACA,oBAAA;ACeJ;ADZA;EACI,aAAA;EACA,sBAAA;EACA,UAAA;ACcJ;ADbI;EAAA;IACI,sBAAA;ECgBN;AACF;ADbA;EACI,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;ACeJ;ADdI;EAAA;IACI,kBAAA;IACA,kBAAA;IACA,eAAA;ECiBN;AACF;ADhBI;EAAA;IACI,YAAA;ECmBN;AACF;ADlBI;EAAA;IACI,cAAA;ECqBN;AACF;ADjBI;EAAA;IACI,iBAAA;ECoBN;AACF;ADnBI;EAAA;IACI,iBAAA;ECsBN;AACF;ADnBA;EACI,qBAAA;ACqBJ;ADlBA;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;ACoBJ;ADlBA;EACI,aAAA;EACA,qBAAA;EACA,SAAA;ACoBJ;ADlBA;EACI,0BAAA;ACoBJ;ADjBA;EACI,yBAAA;ACmBJ;ADjBA;EACI,yBAAA;EACA,mBAAA;EACA,aAAA;ACmBJ;ADjBA;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;ACmBJ;ADhBA;EACI;IACI,kBAAA;ECkBN;AACF;ADbI;EACI,0BAAA;EACA,mBAAA;EACA,kBAAA;ACeR;ADZI;EACI,aAAA;ACcR;ADXI;EACI,0BAAA;EACA,mBAAA;EACA,kBAAA;ACaR;AC1Wc;EAEA,YAAA;AD2Wd;AC1Wc;EAGH,aAAA;AD0WX;ACzWW;EAGE,aAAA;ADyWb;ACxWO;EAGC,aAAA;ADwWR;ACvWG;EAGC,aAAA;ADuWJ;ACvWsB;EAIrB,aAAA;ADsWD;ACtWmB;EAEnB,aAAA;ADuWA;ACrWa;EACA,iBAAA;ADuWb;ACpWY;EAEZ,gBAAA;ADqWA;ACnWgB;EAGhB,8BAAA;ADmWA;AClWiC;EACZ,yBAAA;EAGX,yBAAA;EACK,cAAA;EACZ,eAAA;ADkWH;ACxWiC;EAOhC,eAAA;ADoWD;ACnWM;EACN,yBAAA;ADqWA;AClWG;EAGa,kBAAA;EAEf,aAAA;EAEY,eAAA;EACb,2BAAA;ADgWA;ACxWG;EAUa,qBAAA;EACO,yBAAA;EAEH,kBAAA;ADgWpB;AC/VqB;EAAA;IAEH,yBAAA;EDiWhB;AACF;AC/VC;;EACC,kBAAA;ADkWF;AC9VQ;EAAY,yBAAA;ADiWpB;AC3VA;EANoB,yBAAA;EAOF,qBAAA;AD8VlB;AC7VoB;EAGnB,gCAAA;AD6VD;AC3VoB;EAClB,6BAAA;AD6VF;AC1VqB;EAAQ,oBAAA;AD6V7B;AC1VC;EACK,gBAAA;EAAoB,oBAAA;EAG1B,4BAAA;AD2VA;ACzVC;EALK,gBAAA;EAAoB,oBAAA;EAG1B,4BAAA;EAMC,qBAAA;AD2VD;AC1VE;EAVI,gBAAA;EAAoB,oBAAA;EAG1B,4BAAA;EAUU,qBAAA;AD6VV;AC5Va;EAdP,gBAAA;EAAoB,oBAAA;EAG1B,4BAAA;EAeK,qBAAA;AD8VL;AC7VU;EAnBJ,gBAAA;EAAoB,oBAAA;EAG1B,4BAAA;EAoBC,qBAAA;AD+VD;AC9VI;EAAoB,qBAAA;EACA,sBAAA;ADiWxB;AC9VoB;EACL,qBAAA;EACA,mBAAA;ADgWf;AC7VQ;EACA,cAAA;EACR,YAAA;EAAgB,mBAAA;EAGD,kBAAA;EACM,cAAA;AD8VrB;AC7VkB;EAGb,YAAA;AD6VL;AC5VI;EAEU,0BAAA;AD6Vd;AC5Va;EACD,cAAA;EAGV,kBAAA;EACO,QAAA;EAER,OAAA;EACS,WAAA;EAAe,UAAA;AD4VzB;AC5VwC;EACf,SAAA;EAGvB,kBAAA;EACC,QAAA;EAAY,SAAA;EACN,oCAAA;EAGR,gCAAA;AD2VD;ACvVE;EACF,YAAA;EACE,WAAA;ADyVF;ACzVkB;EAzCH,qBAAA;EACA,mBAAA;EA2Cd,iBAAA;EAAuB,mBAAA;EACjB,kBAAA;EAAwB,mBAAA;EA/FX,yBAAA;EAmGjB,qBAAA;AD2VH;ACxVM;EACK,gBAAA;AD0VX;AC3VM;EAGQ,kBAAA;AD2Vd;AC9VM;;;;;EAOA,gBAAA;EAAwB,eAAA;AD+V9B;ACtWM;EAcN,aAAA;AD2VA;ACzWM;;EAiBE,mBAAA;EAA2B,iBAAA;AD6VnC;AC1VE;EAEU,kBAAA;AD2VZ;AC/VS;EAQF,kBAAA;EACO,UAAA;EACF,YAAA;EACV,SAAA;EAAe,iBAAA;EAGf,YAAA;EAEa,kBAAA;ADwVf;ACxWS;EA3CgB,SAAA;EAGvB,kBAAA;EACC,QAAA;EAAY,SAAA;EACN,oCAAA;EAGR,gCAAA;EA0DA,WAAA;EACD,gBAAA;EAAsB,YAAA;AD2VtB;ACzVC;EA7EW,cAAA;EAGV,kBAAA;EACO,QAAA;EAER,OAAA;EACS,WAAA;EAAe,UAAA;EAwEX,oCAAA;EAEH,sBAAA;AD+VX;ACnWC;EArEwB,SAAA;EAGvB,kBAAA;EACC,QAAA;EAAY,SAAA;EACN,oCAAA;EAGR,gCAAA;EAqE6B,WAAA;EACjB,gBAAA;EACI,YAAA;ADoWjB;AC/VQ;EACK,kBAAA;EACF,mBAAA;EAAuB,4BAAA;ADkWlC;ACjW0B;EAlHX,qBAAA;EACA,mBAAA;EAoHC,eAAA;EACb,gBAAA;ADmWH;ACvW0B;;EAM1B,cAAA;EACG,gBAAA;ADqWH;AClWsB;;;EACJ,cAAA;ADsWlB;ACjX0B;EAvHF,qBAAA;EACA,sBAAA;EAoIhB,eAAA;EAAuB,gBAAA;ADyW/B;ACtWe;EAAA;IAED,gBAAA;EDwWZ;ECrWF;IAAiB,cAAA;IACC,cAAA;IAGV,cAAA;EDsWN;AACF;ACjWa;EACR,kBAAA;EACC,WAAA;EAGK,aAAA;EACV,qBAAA;EACoB,8BAAA;EAGL,eAAA;AD+VhB;AC9VkB;EACN,cAAA;EAEZ,eAAA;AD+VA;AC3VM;EAAA;IACY,YAAA;IACR,WAAA;ED8VR;AACF;AC9V0B;EACX,gBAAA;EACI,eAAA;EACC,gBAAA;EACN,WAAA;EAAmB,aAAA;EAClB,eAAA;EAER,yBAAA;ADgWP;AC9VA;EAAA;IACY,WAAA;IAAqB,aAAA;IACZ,iBAAA;IAElB,2BAAA;EDiWD;AACF;AC/VmB;EACT,kBAAA;ADiWV;AChWa;EAEV,WAAA;EACD,4BAAA;ADiWF;AChWuB;EAEA;IACJ,WAAA;IACC,4BAAA;EDiWlB;AACF;AChW0B;EACtB,mBAAA;EAGJ,eAAA;ADgWA;AChWuB;EAET,kBAAA;ADiWd;AChWQ;EAAA;IACgB,QAAA;EDmWtB;AACF;ACjWY;EAAiB,kBAAA;EACT,mBAAA;ADoWpB;AClWA;EAAuB,kBAAA;ADqWvB;ACjWO;EACU,kBAAA;EACF,UAAA;EACN,aAAA;EACE,qBAAA;EACA,8BAAA;EACC,eAAA;EAET,YAAA;ADkWH;AChWO;EAAA;IAEP,WAAA;IAAqB,kBAAA;EDmWnB;AACF;AC/Vc;EACG,gBAAA;EACC,eAAA;EACN,gBAAA;EACA,YAAA;EACP,aAAA;EACE,sBAAA;EACQ,eAAA;EACP,yBAAA;EACN,YAAA;EAAoB,0BAAA;ADkWtB;AChWW;EAAkB,aAAA;ADmW7B;ACjWC;EAAA;IACO,WAAA;IAEK,aAAA;IACD,iBAAA;IACE,2BAAA;EDmWZ;AACF;AClWQ;EAAA;IAEP,WAAA;IAAqB,gBAAA;EDqWpB;AACF;ACpWG;EAAyB,kBAAA;EACR,YAAA;EACD,mBAAA;ADuWnB;ACtWW;EACO,gBAAA;ADwWlB;ACtWiB;EACA,WAAA;EACD,cAAA;EACA,8BAAA;EACY,YAAA;EAEzB,WAAA;EAAqB,gBAAA;ADwWxB;ACvWe;EAAA;IAEV,UAAA;EDyWH;AACF;ACzXG;EAmBW,YAAA;ADyWd;ACxWe;EAEb;IACQ,WAAA;EDyWR;AACF;ACxWW;EAAA;IACE,WAAA;ED2WX;AACF;AC3WuB;EACA,mBAAA;EACd,eAAA;AD6WT;AC5WS;EACF,iBAAA;AD8WP;AC7WO;EAAA;IACC,QAAA;EDgXN;AACF;AC9WG;EACY,kBAAA;EAEN,mBAAA;EACR,YAAA;AD+WD;AC/W4B;EAxVR,yBAAA;EA4VT,oBAAA;EACT,WAAA;EAIkB,YAAA;EAGjB,0BAAA;AD0WH;ACxW+B;EAE3B,YAAA;EAEJ,WAAA;EACO,YAAA;EAAgB,+BAAA;EAEjB,eAAA;EAAmB,mBAAA;EACL,oBAAA;EAKd,kBAAA;EAAsB,mBAAA;EAEjB,sBAAA;EACU,gBAAA;EACP,mBAAA;EAAuB,gBAAA;EAAoB,uBAAA;ADuWzD;ACtWyB;EAAA;IAAgC,YAAA;IAC1C,WAAA;ED0Wb;AACF;AC3WkC;EAAoC,aAAA;EAGjE,mBAAA;EAAuB,YAAA;EACd,YAAA;EACD,6BAAA;EAEC,mBAAA;EACb,8BAAA;EACc,kBAAA;EACF,eAAA;AD4Wb;AC3WO;EAAA;IACS,WAAA;IACP,gBAAA;ED8WP;AACF;AC9WO;EACA,0BAAA;ADgXP;AC/Wc;EACa,kBAAA;EACN,YAAA;EACf,aAAA;EACF,YAAA;EACF,WAAA;EAEO,QAAA;ADgXT;AChXqB;EACrB,gBAAA;EACI,kBAAA;EACA,aAAA;EACE,8CAAA;EAEC,gBAAA;EACF,YAAA;EAAkB,iBAAA;EACZ,kBAAA;ADkXX;ACjXe;EACY,kBAAA;EAE3B,YAAA;EAAgB,aAAA;EAIhB,YAAA;EAAgB,WAAA;EACL,QAAA;ADiXX;ACjXuB;EAGvB,gBAAA;EAAsB,kBAAA;EACT,aAAA;EACJ,8CAAA;EAGA,gBAAA;EAEP,YAAA;EACK,iBAAA;EACA,kBAAA;AD+WP;AC9WQ;EACC,gBAAA;EAAoB,iBAAA;ADiX7B;AChXU;;;EACJ,0BAAA;ADoXN;AClXI;EAAe,kBAAA;EAIb,UAAA;EAAc,QAAA;EACnB,YAAA;EAAgB,WAAA;EACR,YAAA;EACD,iBAAA;EACG,eAAA;ADoXX;AC5XI;EAUO,gBAAA;ADqXX;AC/XI;EAYc,iBAAA;EACA,mBAAA;ADsXlB;AC7WC;EACM,kBAAA;EACC,sBAAA;AD+WR;AC7WC;EACE,gBAAA;EAAoB,qBAAA;EAGtB,cAAA;EAGD,aAAA;EAAiB,WAAA;AD6WjB;ACpXC;EASI,cAAA;EACO,oBAAA;EAEP,iBAAA;EACM,mBAAA;EACG,oBAAA;AD6Wd;ACzWG;EAIa,aAAA;ADwWhB;AC5WG;EAOA,gBAAA;EACH,iBAAA;EAAuB,kBAAA;EAErB,iBAAA;EACG,sBAAA;ADwWL;ACnXG;EAYoB,mBAAA;EAGN,yBAAA;ADwWjB;ACvXG;EAiBsB,qBAAA;EAIxB,eAAA;EACA,kBAAA;EAAwB,SAAA;EACX,UAAA;EACJ,SAAA;ADuWV;AC/XG;EA2BG,cAAA;EACD,eAAA;EAAqB,kBAAA;EACH,SAAA;EACT,UAAA;EACX,SAAA;ADwWH;ACvYG;EAsCF,cAAA;ADoWD;AC1YG;EA0CU,aAAA;ADmWb;AC7YG;EA8CA,aAAA;ADkWH;AChZG;EAmDa,cAAA;ADgWhB;ACnZG;EAuDwB,mBAAA;EAEzB,iBAAA;AD8VF;AC5VQ;EACK,gBAAA;EAGH,kBAAA;EACC,kBAAA;EACC,iBAAA;EACD,mBAAA;EACF,kBAAA;EACM,kBAAA;AD4Vf;ACzVC;EACa,cAAA;EAAoB,kBAAA;EAC/B,QAAA;EAAc,SAAA;AD6VjB;AC1VM;EAAc,WAAA;EAAiB,kBAAA;EAC/B,QAAA;EACN,UAAA;EAES,WAAA;EAAiB,iBAAA;EAAuB,iBAAA;AD+VjD;AC9VY;EAGC,YAAA;EAAgB,cAAA;AD+V7B;AC/VgD;EACjC,kBAAA;EAGN,eAAA;AD+VT;AC/V6B;EAC3B,kBAAA;ADiWF;AChWC;EAAkB,eAAA;ADmWnB;ACrW6B;EAOd,gBAAA;ADiWf;ACxW6B;;EAST,qBAAA;EAEf,sBAAA;ADkWL;AC7W6B;EAaf,gBAAA;ADmWd;AChX6B;EAiB1B,WAAA;ADkWH;ACjWQ;EAAW,eAAA;ADoWnB;ACpWQ;;;;;EAMJ,eAAA;ADqWJ;AC3WQ;EAOM,iBAAA;ADuWd;ACnWC;EAAa,YAAA;ADsWd;AClWI;EAxlBgB,yBAAA;EAOF,qBAAA;ADu7BlB;ACtWI;EAEa,kBAAA;ADuWjB;ACzWI;EAMD,WAAA;EAAmB,cAAA;EAErB,YAAA;EAED,iBAAA;ADqWA;AC/WI;EAaH,YAAA;EAAkB,WAAA;ADsWnB;ACnXI;EAgBU,iBAAA;ADsWd;ACrWuB;EAGX,kBAAA;EACV,YAAA;EACM,aAAA;EAGc,mBAAA;EAKpB,oBAAA;EAMA,gBAAA;AD0VF;AC7WuB;EA5hBE,SAAA;EAGvB,kBAAA;EACC,QAAA;EAAY,SAAA;EACN,oCAAA;EAGR,gCAAA;ADy4BD;AC/VC;EAAY,kBAAA;EAGP,qBAAA;EACe,YAAA;EAGf,YAAA;AD8VN;ACrWC;EAQA,UAAA;EACC,QAAA;EAAc,SAAA;ADiWhB;AC1WC;EAec,yBAAA;AD8Vf;AC3VK;EAAiB,8BAAA;AD8VtB;AChXC;EAsBqB,UAAA;EACL,WAAA;EACF,YAAA;AD6Vf;ACrXC;EA6Be,2BAAA;AD2VhB;ACxXC;EAiCiB,UAAA;EAEjB,kBAAA;EAGc,eAAA;EACd,MAAA;EAAY,OAAA;EACV,QAAA;EAAc,SAAA;EAAe,sBAAA;EACZ,wBAAA;EACZ,gBAAA;EAAqB,YAAA;ED2V3B,oBAAoB;AACtB;ACtYC;EA2CyB,kBAAA;EACtB,QAAA;EAAgB,UAAA;EAGd,WAAA;AD6VN;ACvVA;EACK,mBAAA;ADyVL;ACxVc;EACH,kBAAA;AD0VX;ACvVM;EACM,kBAAA;EAEN,WAAA;EAGJ,YAAA;EAAoB,WAAA;EACR,SAAA;EAAiB,WAAA;EAG/B,uBAAA;EAA+B,wBAAA;EAGjB,gBAAA;ADqVd;ACnVS;EACC,YAAA;EACL,gBAAA;EAGM,iBAAA;EACJ,iBAAA;EAAqB,cAAA;ADoV5B;AC1VS;;EA5pBe,qBAAA;EACA,sBAAA;AD0/BxB;AC/VS;;;;;EAiBC,eAAA;EACN,qBAAA;EACF,gBAAA;EACE,WAAA;EAEF,cAAA;ADoVF;AC1WS;EAwBO,wBAAA;EAEJ,mBAAA;EAGH,cAAA;EAEH,gBAAA;EACJ,iBAAA;ADiVF;AC9UG;EAAmB,iBAAA;EAGf,2BAAA;EACe,aAAA;EACV,gBAAA;AD+UZ;AC9Ua;EAEZ,mBAAA;AD+UD;AE1oCA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;AF4oCF;AEzoCA;EACE,WAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,qBAAA;EACA,sBAAA;AF2oCF;AEjpCA;EASI,WAAA;EACA,YAAA;AF2oCJ;AEvoCA;EACE,eAAA;AFyoCF;AEtoCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AFwoCF;AEroCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AFuoCF;AEpoCA;EACE,WAAA;EACA,cAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EAEA,mBAAA;EACA,wDAAA;EACA,gDAAA;EACA,iCAAA;EACA,yBAAA;AFqoCF;AEloCA;EACE,gCAAA;EACA,wBAAA;AFooCF;AEjoCA;EACE,gCAAA;EACA,wBAAA;AFmoCF;AEhoCA;EACE,gCAAA;EACA,wBAAA;AFkoCF;AE/nCA;EACE,iCAAA;EACA,yBAAA;AFioCF;AE9nCA;EACE,iCAAA;EACA,yBAAA;AFgoCF;AE7nCA;EACE,iCAAA;EACA,yBAAA;AF+nCF;AE5nCA;EACE,iCAAA;EACA,yBAAA;AF8nCF;AE3nCA;EACE,iCAAA;EACA,yBAAA;AF6nCF;AE1nCA;EACE,iCAAA;EACA,yBAAA;AF4nCF;AEznCA;EACE,iCAAA;EACA,yBAAA;AF2nCF;AExnCA;EACE,iCAAA;EACA,yBAAA;AF0nCF;AEvnCA;EACE,8BAAA;EACA,sBAAA;AFynCF;AEtnCA;EACE,4BAAA;EACA,oBAAA;AFwnCF;AErnCA;EACE,8BAAA;EACA,sBAAA;AFunCF;AEpnCA;EACE,8BAAA;EACA,sBAAA;AFsnCF;AEnnCA;EACE,8BAAA;EACA,sBAAA;AFqnCF;AElnCA;EACE,8BAAA;EACA,sBAAA;AFonCF;AEjnCA;EACE,8BAAA;EACA,sBAAA;AFmnCF;AEhnCA;EACE,8BAAA;EACA,sBAAA;AFknCF;AE/mCA;EACE,8BAAA;EACA,sBAAA;AFinCF;AE9mCA;EACE,8BAAA;EACA,sBAAA;AFgnCF;AE7mCA;EACE,8BAAA;EACA,sBAAA;AF+mCF;AE5mCA;EACE;;;IACE,2BAAA;EFgnCF;EE9mCA;IACE,2BAAA;EFgnCF;AACF;AE7mCA;EACE;;;IACE,2BAAA;IACA,mBAAA;EFinCF;EE/mCA;IACE,2BAAA;IACA,mBAAA;EFinCF;AACF;AE7mCA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;ED3HkB,yBAAA;EAOF,qBAAA;ADquClB;AExnCA;;EAYI,WAAA;EACA,YAAA;EACA,gBAAA;EDrFoB,qBAAA;EACA,sBAAA;ADssCxB;AEhoCA;EAmBI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;AFgnCJ;AE7mCE;EACE,YAAA;AF+mCJ;AEhnCE;;EAKM,WAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;AF+mCR;AGh1CA;EF4EoB,yBAAA;EAOF,qBAAA;EEjFhB,kBAAA;AHm1CF;AGh1CI;EFkFH,gCAAA;EEhFK,kBAAA;AHk1CN;AGh1CI;EACE,mBAAA;AHk1CN;AG51CA;EFuFC,gCAAA;EErEK,kBAAA;AH80CN;AG30CI;EFkEH,gCAAA;EEhEK,kBAAA;AH60CN;AG/0CI;EAKI,mBAAA;AH60CR;AGv0CM;;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AH00CR;AGj3CA;EAgDQ,kBAAA;EACA,kBAAA;EACA,eAAA;AHo0CR;AGl0CQ;EACE,kBAAA;EACA,iBAAA;AHo0CV;AGt0CQ;EAKI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;AHo0CZ;AG9zCM;;EAEE,kBAAA;EACA,iBAAA;EACA,iBAAA;AHg0CR;AG9zCQ;;;;;;;;EACE,eAAA;AHu0CV;AG90CM;;EAYI,aAAA;AHs0CV;AGl1CM;;EAgBI,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AHs0CV;AG51CM;;EA0BI,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EFpBU,yBAAA;EAOF,qBAAA;EEeR,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AHu0CV;AG56CA;EA2GQ,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;AHo0CR;AGn7CA;EAkHU,iBAAA;EACA,iBAAA;AHo0CV;AGv7CA;EAsHU,iBAAA;AHo0CV;AI17CA;EACI,QAAA;EACA,aAAA;EACA,8BAAA;EACA,yBAAA;EACA,cAAA;EACA,UAAA;EACA,0BAAA;EACA,aAAA;AJ47CJ;AIz7CA;EACI,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AJ27CJ;AKn9CA;EACI,cAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,oCAAA;EACA,wBAAA;EACA,2BAAA;EACA,kCAAA;EACA,0BAAA;ALq9CJ;AKl9CA;EACI,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;ALo9CJ;AKj9CA;EACI,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;ALm9CJ;AKh9CA;EACI,eAAA;EACA,WAAA;ALk9CJ;AK/8CA;EACI,QAAA;EACA,SAAA;EACA,YAAA;EACA,gCAAA;EACA,kBAAA;ALi9CJ;AK98CA;EACI,gBAAA;EACA,YAAA;ALg9CJ;AA7/CA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;AA+/CF;AAngDA;ECqF6B,oBAAA;ED7EzB,kBAAA;AA+/CJ;AAvgDA;EAYI,WAAA;EACA,cAAA;AA8/CJ;AA3gDA;EAkBM,eAAA;AA4/CN;AA9gDA;EAuBI,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;AA0/CJ;AAzhDA;EAmCI,mBAAA;EACA,kBAAA;AAy/CJ;AA7hDA;EAwCI,iBAAA;AAw/CJ;AAhiDA;EA4CI,YAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;AAu/CJ;AAr/CI;;;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;AAy/CN;AApjDA;EA+DM,kBAAA;EACA,YAAA;EACA,UAAA;AAw/CN;AAzjDA;EAsEI,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;AAs/CJ;AAlkDA;EAgFI,gBAAA;AAq/CJ;AArkDA;EAoFI,aAAA;AAo/CJ;AAxkDA;EAwFI,YAAA;AAm/CJ;AA3kDA;EA4FI,mBAAA;EACA,qBAAA;EACA,WAAA;AAk/CJ;AAhlDA;EAkGI,YAAA;AAi/CJ;AAnlDA;EAsGI,YAAA;EACA,kBAAA;EACA,cAAA;AAg/CJ;AAxlDA;EA2GM,gBAAA;AAg/CN;AA3lDA;EAgHI,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AA8+CJ;AAjmDA;EAuHI,sBAAA;EACA,oBAAA;EACA,aAAA;AA6+CJ;AAtmDA;EA6HI,gBAAA;AA4+CJ;AAzmDA;EAiII,kBAAA;EACA,cAAA;AA2+CJ;AA7mDA;EAsII,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;AA0+CJ;AAtnDA;EAgJI,mBAAA;AAy+CJ;AAznDA;EAqJI,cAAA;EACA,aAAA;AAu+CJ;AAn+CI;;ECpCW,qBAAA;EACA,mBAAA;AD2gDf;AAn+CI;EACE,YAAA;AAq+CN;AAl+CI;EACE,yBAAA;EACA,kBAAA;AAo+CN;AAzoDA;;EAyKI,2BAAA;EACA,iBAAA;AAo+CJ;AA9oDA;EA6KI,iBAAA;AAo+CJ;AAjpDA;EAiLI,mBAAA;EACA,kBAAA;AAm+CJ;AArpDA;EAqLI,aAAA;EACA,qBAAA;EACA,SAAA;AAm+CJ;AA/9CA;EACE,aAAA;AAi+CF;AA99CA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAg+CF;AA/9CE;EAAA;IACE,yBAAA;EAk+CF;AACF;AAj+CE;EAAA;IACE,yBAAA;EAo+CF;AACF;AAn+CE;EAAA;IACE,wBAAA;EAs+CF;AACF;AAn+CA;EACE,aAAA;EACA,eAAA;AAq+CF;AAl+CA;EACE,eAAA;EACA,gBAAA;AAo+CF;AAj+CA;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;AAm+CF;AAh+CA;EACE,eAAA;AAk+CF;AAh+CE;EAAA;IACE,eAAA;EAm+CF;AACF;AAh+CA;EClKoB,yBAAA;ADqoDpB;AAn+CA;EAII,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,YAAA;AAk+CJ;AAj+CI;EAAA;IACE,YAAA;EAo+CJ;AACF;AAn+CI;EAAA;IACE,WAAA;EAs+CJ;AACF;AAn/CA;EClKoB,yBAAA;EDoLZ,oBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;AAq+CR;AAp+CQ;EAAA;IACE,YAAA;IACA,aAAA;EAu+CR;AACF;AAt+CQ;EAAA;IACE,WAAA;IACA,YAAA;EAy+CR;AACF;AAtgDA;EAmCI,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;AAs+CJ;AAp+CI;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;AAs+CN;AAz+CI;EAMI,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;AAs+CR;AA7hDA;;;EA8DM,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;AAo+CN;AAriDA;EAqEM,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;AAm+CN;AA3iDA;EA4EM,cAAA;EACA,gBAAA;EACA,qBAAA;AAk+CN;AAh+CM;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;AAk+CR;AAh+CQ;EACE,kBAAA;AAk+CV;AA/9CQ;EACE,eAAA;EACA,kBAAA;AAi+CV;AA7jDA;EAkGM,gBAAA;EACA,cAAA;AA89CN;AAjkDA;EAyGM,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;AA29CN;AAvkDA;EAiHQ,sBAAA;EACA,aAAA;EACA,mBAAA;AAy9CR;AA5kDA;EAsHU,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;AAy9CV;AAp9CU;;EAEE,cAAA;AAs9CZ;AAtlDA;;;;;;EA0IU,qBAAA;EACA,sBAAA;AAo9CV;AA/lDA;EA+IU,mBAAA;AAm9CV;AAlmDA;EAmJU,qBAAA;EACA,wBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,6BAAA;AAk9CV;AAh9CU;EACE,cAAA;AAk9CZ;AAlnDA;EAuKM,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AA88CN;AA78CM;EAAA;IACE,eAAA;IACA,iBAAA;EAg9CN;AACF;AA98CM;EACE,mBAAA;AAg9CR;AA18CA;EACE,eAAA;AA48CF;AAz8CA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AA28CF;AA18CE;EAAA;IACE,kBAAA;IACA,gBAAA;EA68CF;AACF;AA58CE;EAAA;IACE,kBAAA;IACA,eAAA;EA+8CF;AACF;AA39CA;EAcI,WAAA;EACA,kBAAA;AAg9CJ;AA/9CA;EAkBI,yBAAA;EACA,qBAAA;EACA,8BAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,+BAAA;EACA,iBAAA;EAAmB,cAAA;EACnB,yBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAi9CJ;AAh9CI;EAAA;IACE,kBAAA;IACA,gBAAA;EAm9CJ;AACF;AAl9CI;EAAA;IACE,kBAAA;IACA,eAAA;EAq9CJ;AACF;AAj9CA;EACE,aAAA;AAm9CF;AAh9CA;;EAGI,aAAA;EACA,mBAAA;AAi9CJ;AA78CA;EACE;IAEI,kBAAA;IACA,gBAAA;EA88CJ;AACF;AA18CA;EACE;IACE,aAAA;EA48CF;EA78CA;IAII,WAAA;EA48CJ;EAh9CA;IAQI,yBAAA;IACA,YAAA;EA28CJ;EAx8CM;IACE,cAAA;IACA,eAAA;IACA,cAAA;IACA,qBAAA;IACA,WAAA;IACA,YAAA;EA08CR;EAx8CQ;IACE,kBAAA;EA08CV;EA/9CA;IA2BM,aAAA;EAu8CN;AACF;AAl8CA;;;;;EAKE,qBAAA;AAo8CF;AAl8CA;EACE,yBAAA;EACA,iBAAA;AAo8CF;AAl8CA;EAEI;IACE,yBAAA;EAm8CJ;AACF;AAh8CA;EAEI;IACE,yBAAA;EAi8CJ;AACF;AA97CA;EACE;IACE,kBAAA;EAg8CF;EAj8CA;IAGI,WAAA;IACA,cAAA;EAi8CJ;AACF;AA77CA;EACE,cAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA+7CF;AAr8CA;EASI,cAAA;AA+7CJ;AA37CA;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AA67CF;AA17CA;EACE,gBAAA;AA47CF","sourcesContent":["@import './constants.less';\n\nul, li {\n    list-style: none;\n    padding: 0px;\n    margin: 0px;\n}\n.left {\n    float: left;\n}\n.right {\n    float: right;\n}\n.clear-fix:after {\n    content: \" \";\n    display: block;\n    clear: both;\n    float: none;\n}\n\n.btn+.btn {\n    margin: 0 !important;\n}\n\np {\n    word-break: break-word;\n}\n\n.full-height {\n    height: 100%;\n}\n\nimg {\n    max-width: 100%;\n}\n\n.favourite-icon {\n    cursor: pointer;\n}\n\n.favourite-participant-icon {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    padding: 6px 8px;\n    width: 100%;\n    @media only screen and (min-width: 1200px) {\n        padding: 3px;\n        width: 300px;\n        float: right;\n    }\n    @media only screen and (min-width: 1025px) and (max-width: 1199px){\n        padding: 3px;\n        width: 250px;\n        float: right;\n    }\n    @media only screen and (min-width: 768px) and (max-width: 1024px) {\n        padding: 3px;\n        width: 200px;\n        float: right;\n    }\n    @media only screen and (min-width: 320px) and (max-width : 767px) {\n        padding: 8px;\n        max-width: fit-content;\n    }\n    @media (max-width: 767px){\n        display: block;\n    }\n\n}\n.favourite-icon-container {\n    @media only screen and (min-width: 1025px){\n        padding-left: 10px;\n    }\n}\n\n.favourite-icon-img {\n    vertical-align: middle;\n    margin-right: 2.5px;\n    margin-left: 2.5px;\n}\n\n.favourite-icon-label {\n    padding-left: 8px;\n}\n\n.favourite-unselect-fill-opacity {\n    fill-opacity: 0.0;\n}\n.directory-favourite-icon {\n    display: inline-flex;\n}\n.label.label-in-list {\n    display: inline-block;\n    word-break: break-word;\n    white-space: normal;\n    margin: .2rem .8rem .2rem 0;\n    color: #2d2d2d;\n}\n.participant-profile-container {\n    .feature-filter-label-list {\n        display: inline-block;\n        div {\n        float: left;\n        margin-right: 10px;\n        }\n        .feature-filter-label {\n            border: solid 2px #dddddd;\n            display: inline-block;\n            background-color: var(--white);\n            height: auto;\n            padding: 2.4px 10px;\n            margin-top: 0.8rem;\n            border-radius: 10px;\n            color: #2d2d2d;\n            font-family: Roboto, sans-serif;\n            font-weight: bold; font-size: 9px;\n            text-transform: uppercase;\n            line-height: normal;\n            word-break: break-word;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            overflow: hidden;\n        }\n    }\n\n    @media (max-width: 768px) {\n        .feature-filter-label-list {\n            div {\n            height: 40px;\n            }\n        }\n    }\n}\n\n\n.network-participant-icon {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    padding: 3px 8px;\n    width: 100%;\n    @media only screen and (min-width: 1200px) {\n        padding: 3px;\n        width: 300px;\n        float: right;\n    }\n    @media only screen and (min-width: 1025px) and (max-width: 1199px){\n        padding: 3px;\n        width: 250px;\n        float: right;\n    }\n    @media only screen and (min-width: 768px) and (max-width: 1024px) {\n        padding: 3px;\n        width: 200px;\n        float: right;\n    }\n    @media only screen and (min-width: 320px) and (max-width : 767px) {\n        padding: 8px;\n        max-width: fit-content;\n    }\n    @media (max-width: 767px){\n        display: block;\n    }\n}\n\n.network-icon-container {\n    @media only screen and (min-width: 1025px){\n        padding-left: 10px;\n    }\n    width: 100%;\n    .right {\n        display: flex;\n        flex-direction: column;\n        width: 390px;\n    }\n    .text-danger {\n       font-size: 80%;\n       margin-top: 5px;\n    }\n}\n\n.chat-icon-container{\n    @media only screen and (min-width: 1025px){\n        padding-left: 10px;\n    }\n    width: 100%;\n    .right {\n        display: flex;\n        flex-direction: column;\n        width: 390px;\n    }\n    .text-danger {\n       font-size: 80%;\n       margin-top: 5px;\n    }\n}\n\n.chat-participant-div {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    padding: 6px 8px;\n    width: 100%;\n    @media only screen and (min-width: 1200px) {\n        padding: 3px;\n        width: 300px;\n        float: right;\n    }\n    @media only screen and (min-width: 1025px) and (max-width: 1199px){\n        padding: 3px;\n        width: 250px;\n        float: right;\n    }\n    @media only screen and (min-width: 768px) and (max-width: 1024px) {\n        padding: 3px;\n        width: 200px;\n        float: right;\n    }\n    @media only screen and (min-width: 320px) and (max-width : 767px) {\n        padding: 8px;\n        max-width: fit-content;\n    }\n    @media (max-width: 767px){\n        display: block;\n    }\n}\n\n.mobile-view-icon {\n    @media only screen and (min-width: 768px) {\n        display: none;\n    }\n    @media only screen and (max-width : 767px) {\n        display: inline-block;\n    }\n}\n\n.desktop-view-icon {\n    @media only screen and (min-width: 768px) {\n        display: inline-block;\n    }\n    @media only screen and (max-width : 767px) {\n        display: none;\n    }\n}\n\n.network-digital-portfolio-name-container{\n    display: block;\n    align-items: baseline;\n    justify-content: center;\n    text-align: center;\n    vertical-align: middle;\n    padding-top: 15px;\n}\n\n.network-digital-portfolio-name{\n    font-size: 80%;\n    padding: 2px 0 0 2px;\n}\n\n.icon-container {\n    display: flex;\n    flex-direction: column;\n    flex: auto;\n    @media only screen and (min-width: 320px) and (max-width : 767px) {\n        max-width: fit-content;\n    }\n}\n\n.network-icon-profile{\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    width: @participantContact;\n    @media only screen and (min-width: 768px) and (max-width: 1024px) {\n        padding: 7.5px 8px;\n        margin-left: @participantThumbnailSize;\n        margin-top: 8px;\n    }\n    @media only screen and (min-width: 320px) and (max-width : 767px) {\n        padding: 8px;\n    }\n    @media (max-width: 767px){\n        display: block;\n    }\n}\n\n.custom-overlay-tooltip {\n    @media (max-width:450px) {\n        margin-left: 55px;\n    }\n    @media (min-width: 451px) {\n        margin-left: 53px;\n    }\n}\n\n.new-line {\n    white-space: pre-line;\n}\n\n.error-message-link{\n    color: @alertDanger;\n    font-weight: bold;\n    margin-left: 3px;\n}\n.profile-image-error{\n    display: flex;\n    align-items: baseline;\n    gap: 1rem;\n}\n.underline{\n    text-decoration: underline;\n}\n\n.image-container-highlight {\n    border: solid #E26363 2px;\n}\n.participant-banner-highlight {\n    border: solid #E7B810 2px;\n    border-radius: 10px;\n    padding: 15px;\n}\n.participant-banner-highlight-text {\n    color: #995E00;\n    font-weight: 600;\n    cursor: pointer;\n    font-size: 20px;\n    margin-top: 10px;\n}\n\n@media (max-width: 991px) {\n    .participant-banner-highlight-text {\n        text-align: center;\n     }\n}\n\n// Copy Component accessibility styles\n[data-testid=\"Copy-Component\"] {\n    &:focus {\n        outline: 2px solid #337ab7;\n        outline-offset: 2px;\n        border-radius: 3px;\n    }\n    \n    &:focus:not(:focus-visible) {\n        outline: none;\n    }\n    \n    &:focus-visible {\n        outline: 2px solid #337ab7;\n        outline-offset: 2px;\n        border-radius: 3px;\n    }\n}\n","@import './common.less';\n@import './constants.less';\n@import './mixins.less';\n@import './spinner.less';\n@import './accordian.less';\n@import './feedbackButton';\n@import './surveyPopup';\n\n.participant-directory {\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  letter-spacing: normal;\n\n  h1 {\n    .h2();\n    text-align: center;\n  }\n\n  .infinite-scroll-component {\n    width: 100%;\n    display: block;\n  }\n\n  .list-container {\n    .big-spinner {\n      margin-top: 4em;\n    }\n  }\n\n  .email-activation h4 {\n    background: none;\n    font-size: 14px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.67;\n    letter-spacing: normal;\n    display: inline;\n    color: #337ab7;\n  }\n\n  .confirmation-text p {\n    margin-right: 350px;\n    margin-left: 350px;\n  }\n\n  .confirmation-text strong {\n    font-size: 1.9rem;\n  }\n\n  button#email-activation-toggle {\n    height: 24px;\n    font-size: 14px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.71;\n    letter-spacing: normal;\n    color: #0065bc;\n    border: none;\n    background: none;\n    padding: 2px 0 0 0px;\n\n    &:hover, &:active, &:focus {\n      outline: white;\n      box-shadow: none;\n      outline-color: #fff;\n    }\n\n    i {\n      position: relative;\n      bottom: -2px;\n      left: 10px;\n    }\n  }\n\n  .email-activation-text p {\n    font-size: 14px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.71;\n    letter-spacing: normal;\n    color: #2d2d2d;\n  }\n\n  .padding-zero {\n    padding-right: 0;\n  }\n\n  .display-none {\n    display: none;\n  }\n\n  .float-right {\n    float: right;\n  }\n\n  .send-activation-email-button {\n    font-weight: normal;\n    margin-bottom: .8rem;\n    float: left;\n  }\n\n  .hide-contact-details-toggle {\n    float: right;\n  }\n\n  .participant_report_donwload_button {\n    float: right;\n    margin-right: 15px;\n    display: block;\n\n    .fa-circle-arrow-down{\n      font-weight: 900;\n    }\n  }\n\n  .cancel-email-button {\n    color: black;\n    background: white;\n    border: 2px solid #dddddd;\n    margin-top: 0.8rem\n  }\n\n  #email-collapse-text {\n    border: 1px solid grey;\n    margin: 5px 0 10px 0;\n    padding: 10px;\n  }\n\n  .email-activation button {\n    background: none;\n  }\n\n  .confirmation-text {\n    text-align: center;\n    margin: 0 auto;\n  }\n\n  .email-status-text h4 {\n    font-size: 14px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 0.67;\n    letter-spacing: normal;\n    color: #2d2d2d;\n  }\n\n  .email-status-text {\n    margin-bottom: 10px;\n  }\n\n\n  .result-count {\n    display: block;\n    padding: 10px;\n  }\n\n  .directory-content {\n    & > .hierachical-filter,\n    & > .ais-InstantSearch__root {\n      .verticalTop();\n    }\n\n    & > .hierachical-filter {\n      width: 285px;\n    }\n\n    & > .ais-InstantSearch__root {\n      width: calc(100% - 285px);\n      padding-left: 20px;\n    }\n  }\n  .admin-email-activation, .non-admin-email-activation {\n    border-top: solid black 1px;\n    padding-top: 15px;\n  }\n  .non-admin-mercury-email-activation {\n    padding-top: 15px;\n  }\n  i.fa-solid.fa-triangle-exclamation.fa-fw\n  {\n    width: 1.28571429em;\n    margin-right: 10px;\n  }\n  .alert-warning {\n    display: flex;\n    align-items: baseline;\n    gap: 1rem;\n  }\n}\n\n.participant-wrapper {\n  display: flex;\n}\n\n.participant-details-icon-contact-container {\n  display: flex;\n  flex-direction: column;\n  flex: 4 4 0;\n  @media only screen and (min-width: 1025px) {\n    width: calc(100% - @participantThumbnailSize);\n  }\n  @media (min-width: 768px) and (max-width: 991px) {\n    width: calc(100% - @participantThumbnailSizeForTab);\n  }\n  @media (max-width: 767px) {\n    width: calc(100% - @participantThumbnailSizeForMobile);\n  }\n}\n\n.participant-details-icon-container {\n  display: flex;\n  max-width: 100%;\n}\n\n.participant-date-on {\n  font-size: 12px;\n  text-align: left;\n}\n\n.date-component {\n  margin-bottom: 1rem;\n  margin-top: 1rem;\n  color: #6E6E6E;\n}\n\nparticipant-item .participant-details > a h3 {\n  font-size: 24px;\n\n  @media (min-width: 320px) and (max-width: 767px) {\n    font-size: 12px;\n  }\n}\n\n.participant-item {\n  .border();\n\n  .participant-image {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    width: @participantThumbnailSize;\n    @media (min-width: 768px) and (max-width: 991px) {\n      width: @participantThumbnailSizeForTab;\n    }\n    @media (max-width: 767px) {\n      width: @participantThumbnailSizeForMobile;\n    }\n\n    a {\n      img {\n        .border();\n        border-radius: 180px;\n        width: @participantThumbnailSize;\n        height: @participantThumbnailSize;\n        object-fit: cover;\n        @media (min-width: 768px) and (max-width: 991px) {\n          width: @participantThumbnailSizeForTab;\n          height: @participantThumbnailSizeForTab;\n        }\n        @media (max-width: 767px) {\n          width: @participantThumbnailSizeForMobile;\n          height: @participantThumbnailSizeForMobile;\n        }\n      }\n    }\n  }\n\n  .participant-details {\n    padding-left: 20px;\n    padding-right: 15px;\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    flex: 4 4 0;\n\n    & > a {\n      display: block;\n      font-size: 2.8rem;\n      margin-bottom: 5px;\n\n      h3 {\n        font-size: 2.4rem;\n        font-weight: 900;\n        font-style: normal;\n        font-stretch: normal;\n        letter-spacing: normal;\n        word-break: break-word;\n        margin: 0px;\n        line-height: 3rem;\n      }\n    }\n\n    .participant-job-title,\n    .participant-org,\n    .participant-country {\n      margin: 0px;\n      line-height: 3rem;\n      font-size: 1.8rem;\n      word-break: break-word;\n    }\n\n    .participant-job-title {\n      font-weight: 700;\n      color: @participantJobColor;\n      letter-spacing: 0.3px;\n      word-break: break-word;\n    }\n\n    .participant-org {\n      color: @participantJobColor;\n      font-weight: 500;\n      letter-spacing: 0.7px;\n\n      & > span {\n        display: block;\n        vertical-align: top;\n        max-width: 100%;\n        word-break: break-word;\n\n        &:first-child {\n          padding-right: 5px;\n        }\n\n        &:only-child {\n          max-width: 100%;\n          padding-right: 0px;\n        }\n      }\n    }\n\n    .participant-country {\n      font-weight: 400;\n      color: @participantCountry;\n    }\n  }\n\n  .participant-wrapper {\n    .participant-contact-details {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      width: 100%;\n    }\n    .contact-items {\n\n      .contact-item {\n        padding-bottom: 2.5rem;\n        display: flex;\n        align-items: center;\n\n        .label {\n          font-weight   : 500;\n          line-height   : 1.4em;\n          padding       : 0px;\n          text-transform: uppercase;\n        }\n\n        &.greyed-out {\n\n          &,\n          * {\n            color: #696969;\n          }\n        }\n\n        .fa,\n        .fa-solid,\n        .fa-regular,\n        .fa-light,\n        .fa-brands,\n        .value {\n          display       : inline-block;\n          vertical-align: middle;\n        }\n\n        a{\n          padding-right: 35px;\n        }\n\n        .value {\n          word-break  : break-all;\n          width       : calc(100% - 60px);\n          padding-left: 15px;\n          padding-right: 15px;\n          line-height : 2rem;\n          font-size   : 1.6rem;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          flex: 1 1;\n          justify-content: space-evenly;\n\n          &.colored {\n            color: inherit;\n          }\n        }\n      }\n    }\n\n    .contact-items {\n      padding-top: 25px;\n      padding-left: 20px;\n      max-width: 100%;\n      width: fit-content;\n      padding-right: 15px;\n      @media (max-width: 767px) {\n        padding-left: 0;\n        margin-left: 10px;\n      }\n\n      &>.contact-item:nth-child(3) {\n        padding-bottom: 0px;\n      }\n    }\n  }\n}\n\nspan.feature-filter-label:hover {\n  cursor: pointer;\n}\n\n.feature-filter-label-list {\n  display: inline-block;\n  margin-top: 10px;\n  width: fit-content;\n  max-width: @participantThumbnailSize;\n  @media (min-width: 768px) and (max-width: 991px) {\n    width: fit-content;\n    max-width: @participantThumbnailSizeForTab;\n  }\n  @media (max-width: 767px) {\n    width: fit-content;\n    max-width: @participantThumbnailSizeForMobile;\n  }\n  div {\n    float: left;\n    margin-right: 10px;\n  }\n  .feature-filter-label {\n    border: solid 2px #dddddd;\n    display: inline-block;\n    background-color: var(--white);\n    height: auto;\n    padding: 2.4px 10px;\n    margin-top: 0.8rem;\n    border-radius: 10px;\n    color: #2d2d2d;\n    font-family: Roboto, sans-serif;\n    font-weight: bold; font-size: 9px;\n    text-transform: uppercase;\n    line-height: normal;\n    word-break: break-word;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    width: fit-content;\n    max-width: @participantThumbnailSize;\n    @media (min-width: 768px) and (max-width: 991px) {\n      width: fit-content;\n      max-width: @participantThumbnailSizeForTab;\n    }\n    @media (max-width: 767px) {\n      width: fit-content;\n      max-width: @participantThumbnailSizeForMobile;\n    }\n  }\n}\n\n.participant-contact-and-tags {\n  display: flex;\n}\n\n.participant-directory .algolia-component .list-wrapper ul,\n.participant-list .list-container ul {\n  .participant-item {\n    padding: 30px;\n    margin-bottom: 10px;\n  }\n}\n\n@media (max-width: 700px) {\n  .participant-directory {\n    h2 {\n      text-align: center;\n      margin-left: 0px;\n    }\n  }\n}\n\n@media (max-width: 420px) {\n  .participant-item {\n    padding: 20px;\n\n    .participant-image {\n      float: none;\n    }\n\n    .participant-details {\n      margin: 0px 10px 0px 10px;\n      padding: 0px;\n\n      .participant-org {\n        & > span {\n          display: block;\n          max-width: 100%;\n          overflow: auto;\n          white-space: pre-line;\n          margin: 0px;\n          padding: 0px;\n\n          &:first-child {\n            padding-right: 0px;\n          }\n        }\n      }\n\n      .hiphen {\n        display: none;\n      }\n    }\n  }\n}\n\n.algolia-component .algolia-filter h3,\n.algolia-component .algolia-filter .content-wrapper,\n.algolia-component .algolia-filter .leaves .leaf .duplicate-checkbox,\n.algolia-component .algolia-filter .highlevel-filter,\n.algolia-component > .custom-search-header .heading-search-sort .search-bar {\n  border-color: @borderColor;\n}\n.algolia-component > .filter-results {\n  width: calc(100% - 310px);\n  margin-left: 25px;\n}\n@media (max-width: 1199px) {\n  .algolia-component {\n    & > .filter-results {\n      width: calc(100% - 260px);\n    }\n  }\n}\n@media (max-width: 991px) {\n  .algolia-component {\n    & > .filter-results {\n      width: calc(100% - 205px);\n    }\n  }\n}\n@media (max-width: 767px) {\n  .participant-directory .algolia-component {\n    position: relative;\n    .filter-results {\n      width: 100%;\n      margin-left: 0;\n    }\n  }\n}\n\n.participant-pps-list-wrapper{\n  display: block;\n  margin: 0;\n  margin-bottom: 2rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  a{\n    color: #6E6E6E;\n  }\n}\n\n.about-me-text{\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  color: black;\n  font-weight: 400;\n}\n\n.about-me-title{\n  font-weight: 700;\n}\n","@import './constants.less';\r\n\r\n//social media\r\n\r\n.with-opacity {\r\n  opacity: 0.3;\r\n}\r\n\r\n.facebook-logo {\r\n  fill: #3b5998;\r\n}\r\n\r\n.facebook-logo-color {\r\n  fill: #4267b2;\r\n}\r\n\r\n.twitter-logo-color {\r\n  fill: #1da1f2;\r\n}\r\n\r\n.youtube-logo-color {\r\n  fill: #fc0d1c;\r\n}\r\n\r\n.linkedin-logo-color {\r\n  fill: #0077b5;\r\n}\r\n\r\n.wechat-logo-color {\r\n  fill: #51c332;\r\n}\r\n\r\n.activation-email {\r\n  text-align: right;\r\n}\r\n\r\n.activation-email-collapse {\r\n  text-align: left;\r\n}\r\n\r\n.btn+.btn.activation-email-button {\r\n  margin-left: 0.8rem !important;\r\n}\r\n\r\n.resend-email-button {\r\n  background-color: #ffffff;\r\n  border: solid 1px #a2a2a2;\r\n  color: #337ab7;\r\n  font-size: 14px;\r\n\r\n  i {\r\n    font-size: 18px;\r\n  }\r\n\r\n  &:hover {\r\n    background-color: #e2e6ea;\r\n  }\r\n}\r\n\r\n.social-media-logo-container {\r\n  margin-top: 1.5rem;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: flex-start;\r\n\r\n  .social-media-logo {\r\n    display: inline-block;\r\n    width: calc(100% * (1/3));\r\n    margin-bottom: 2em;\r\n\r\n    @media (max-width: 992px) and (min-width: 768px) {\r\n      width: calc(100% * (1/6));\r\n    }\r\n  }\r\n}\r\n\r\n//social media ends here\r\n\r\n.relative, .editable-container {\r\n  position: relative;\r\n}\r\n\r\n.border {\r\n  border: 1px solid @borderColor;\r\n  // border-radius: @borderRadius;\r\n}\r\n\r\n.darkBorder {\r\n  .border();\r\n  border-color: @darkerBorderColor;\r\n}\r\n\r\n.darkBorderBottom {\r\n  border-bottom: 1px solid @darkerBorderColor;\r\n}\r\n\r\n.darkBorderTop {\r\n  border-top: 1px solid @darkerBorderColor;\r\n}\r\n\r\n.h2 {\r\n  margin-bottom: 0.5em;\r\n}\r\n\r\n.multilineOverflow {\r\n  overflow: hidden;\r\n  display: -webkit-box;\r\n  -webkit-box-orient: vertical;\r\n}\r\n\r\n.singleLineOverflow {\r\n  .multilineOverflow();\r\n  -webkit-line-clamp: 1;\r\n}\r\n\r\n.twoLinesOverflow {\r\n  .multilineOverflow();\r\n  -webkit-line-clamp: 2;\r\n}\r\n\r\n.threeLinesOverflow {\r\n  .multilineOverflow();\r\n  -webkit-line-clamp: 3;\r\n}\r\n\r\n.fourLinesOverflow {\r\n  .multilineOverflow();\r\n  -webkit-line-clamp: 4;\r\n}\r\n\r\n.verticalMiddle {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n\r\n.verticalTop {\r\n  display: inline-block;\r\n  vertical-align: top;\r\n}\r\n\r\n.algolia-error {\r\n  display: block;\r\n  padding: 2em;\r\n  background: @algoliaErrorBg;\r\n  text-align: center;\r\n  color: @errorColor;\r\n}\r\n\r\n.submitting {\r\n  opacity: 0.6;\r\n}\r\n\r\n[type='file']::-webkit-file-upload-button {\r\n  -webkit-appearance: button;\r\n}\r\n\r\n.absolute-stretch {\r\n  display: block;\r\n  position: absolute;\r\n  top: 0px;\r\n  left: 0;\r\n  bottom: 0px;\r\n  right: 0px;\r\n}\r\n\r\n.absolute-vertical-center {\r\n  margin: 0;\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  -ms-transform: translate(-50%, -50%);\r\n  transform: translate(-50%, -50%);\r\n}\r\n\r\n.tag-list.participants {\r\n  padding: 0px;\r\n  margin: 0px;\r\n\r\n  & > li {\r\n    .verticalTop();\r\n    padding: 0px 10px;\r\n    background: @tagBg;\r\n    margin-right: 10px;\r\n    margin-bottom: 10px;\r\n    .border();\r\n    border-color: @tagBorderColor;\r\n  }\r\n}\r\n\r\n.file-upload {\r\n  overflow: hidden;\r\n\r\n  .file-upload-wrapper {\r\n    position: relative;\r\n\r\n    .fa, .fa-solid, .fa-regular, .fa-light, .fa-brands {\r\n      padding: 8px 7px;\r\n      cursor: pointer;\r\n    }\r\n\r\n    input[type='file'] {\r\n      display: none;\r\n    }\r\n\r\n    .fa-camera,\r\n    .fa-upload {\r\n      vertical-align: top;\r\n      font-size: 2.4rem;\r\n    }\r\n  }\r\n}\r\n\r\n.profile-image {\r\n  .image-container {\r\n    &.editable {\r\n      position: relative;\r\n    }\r\n  }\r\n\r\n  .file-upload {\r\n    position: absolute;\r\n    right: 2px;\r\n    bottom: 14px;\r\n    top: auto;\r\n    font-size: 2.5rem;\r\n    color: white;\r\n    border-radius: @borderRadius;\r\n  }\r\n\r\n  .spinner {\r\n    .absolute-vertical-center();\r\n    margin: 0px;\r\n    background: none;\r\n    border: none;\r\n  }\r\n}\r\n\r\n.stretchable-spinner {\r\n  .absolute-stretch();\r\n  background: rgba(255, 255, 255, 0.3);\r\n  border: 1px solid gray;\r\n\r\n  .spinner {\r\n    .absolute-vertical-center();\r\n    margin: 0px;\r\n    background: none;\r\n    border: none;\r\n  }\r\n}\r\n\r\n//user settings panel\r\n.logged-in-user-settings {\r\n  text-align: center;\r\n  margin-bottom: 15px;\r\n  padding: 20px 20px 20px 20px;\r\n\r\n  & > li {\r\n    .verticalTop();\r\n    cursor: pointer;\r\n    padding: 0 0.7em;\r\n\r\n    nav, a {\r\n      display: block;\r\n      min-height: auto;\r\n    }\r\n\r\n    &, a, span {\r\n      color: inherit;\r\n    }\r\n\r\n    span {\r\n      .verticalMiddle();\r\n      font-size: 2rem;\r\n      font-weight: 400;\r\n    }\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    & {\r\n      text-align: left;\r\n\r\n      & > li {\r\n        display: block;\r\n        padding: 0.7em;\r\n        color: inherit;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.settings-navbar-list{\r\n  .logged-in-user-settings {\r\n    &__base {\r\n      position: relative;\r\n      width: 100%;\r\n      display: flex;\r\n      align-items: baseline;\r\n      justify-content: space-between;\r\n      flex-wrap: wrap;\r\n    }\r\n    &__welcome {\r\n      display: block;\r\n      font-size: 25px;\r\n      @media (min-width: 768px) {\r\n        flex-grow: 2;\r\n        width: auto;\r\n      }\r\n    }\r\n    &__list {\r\n      list-style: none;\r\n      padding-left: 0;\r\n      padding-right: 0;\r\n      width: 100%;\r\n      display: flex;\r\n      flex-wrap: wrap;\r\n      justify-content: flex-end;\r\n\r\n      @media (min-width: 768px) {\r\n        width: auto;\r\n        display: flex;\r\n        flex-wrap: nowrap;\r\n        justify-content: flex-start;\r\n      }\r\n    }\r\n    &__item {\r\n      padding-left: 10px;\r\n\r\n      &:not(:last-child):after {\r\n        content: \"\";\r\n        border-right: 1px solid gray;\r\n      }\r\n\r\n      @media (min-width: 768px) {\r\n        &:last-child:after {\r\n          content: \"\";\r\n          border-right: 1px solid gray;\r\n        }\r\n      }\r\n    }\r\n    &__link {\r\n      white-space: nowrap;\r\n      font-size: 15px;\r\n      &--logout {\r\n        padding-left: 10px;\r\n        @media (min-width: 768px) {\r\n          order: 3;\r\n        }\r\n      }\r\n    }\r\n    &__label {\r\n      padding-left: 10px;\r\n      padding-right: 10px;\r\n    }\r\n  }\r\n}\r\n\r\n.settings-dropdown {\r\n  position: relative;\r\n  .logged-in-user-settings{\r\n    &__dropdown-base {\r\n      position: absolute;\r\n      z-index: 1;\r\n      display: flex;\r\n      align-items: baseline;\r\n      justify-content: space-between;\r\n      flex-wrap: wrap;\r\n      width: 250px;\r\n      @media (max-width: 480px) {\r\n        width: 100%;\r\n        position: relative;\r\n      }\r\n    }\r\n    &__dropdown-list {\r\n      list-style: none;\r\n      padding-left: 0;\r\n      padding-right: 0;\r\n      width: 250px;\r\n      display: flex;\r\n      flex-direction: column;\r\n      flex-wrap: wrap;\r\n      justify-content: flex-end;\r\n      color: white;\r\n      border-radius: 0 0 4px 4px;\r\n      &__hide {\r\n        display: none;\r\n      }\r\n      @media (min-width: 768px) {\r\n        width: auto;\r\n        display: flex;\r\n        flex-wrap: nowrap;\r\n        justify-content: flex-start;\r\n      }\r\n      @media (max-width: 480px) {\r\n        width: 100%;\r\n        border-radius:0;\r\n      }\r\n\r\n    }\r\n    &__dropdown-item {\r\n      padding-left: 15px;\r\n      width: 250px;\r\n      margin-bottom: 10px;\r\n      &:first-child {\r\n        margin-top: 15px;\r\n      }\r\n      &:not(:last-child):after {\r\n        content: '';\r\n        display: block;\r\n        border-bottom: 1px solid white;\r\n        width: 220px;\r\n        height: 1px;\r\n        margin-top: 10px;\r\n        @media (max-width: 480px) {\r\n          width: 95%;\r\n        }\r\n      }\r\n      span {\r\n        color: white;\r\n      }\r\n      @media (min-width: 768px) {\r\n        &:last-child:after {\r\n          content: \"\";\r\n        }\r\n      }\r\n      @media (max-width: 480px) {\r\n        width: 100%;\r\n      }\r\n\r\n    }\r\n    &__dropdown-link {\r\n      white-space: nowrap;\r\n      font-size: 15px;\r\n      &--logout {\r\n        padding-left: 0px;\r\n        @media (min-width: 768px) {\r\n          order: 3;\r\n        }\r\n      }\r\n    }\r\n    &__dropdown-label {\r\n      padding-left: 10px;\r\n      padding-right: 10px;\r\n      color: white;\r\n    }\r\n  }\r\n}\r\n\r\n.participant-dropdown-image {\r\n  img {\r\n    .border();\r\n    border-radius: 180px;\r\n    width: @loggedInUserSettingsParticipantThumbnailSize;\r\n    height: @loggedInUserSettingsParticipantThumbnailSize;\r\n    max-width: @loggedInUserSettingsParticipantThumbnailSize !important;\r\n  }\r\n}\r\n.participant-dropdown-text {\r\n  color: white;\r\n  width:100%;\r\n  height: 18px;\r\n  margin: 6.5px 35.5px 5.5px 10px;\r\n  font-size: 15px;\r\n  font-weight: normal;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  @media (min-width: 768px) {\r\n    flex-grow: 2;\r\n    width: auto;\r\n  }\r\n}\r\n.participant-dropdown-container {\r\n  display: flex;\r\n  flex-direction: row;\r\n  width: 250px;\r\n  height: 43px;\r\n  padding: 5px 10.5px 10px 15px;\r\n  object-fit: contain;\r\n  border-radius: 4px 4px 4px 4px;\r\n  position: relative;\r\n  cursor: pointer;\r\n  @media (max-width: 480px) {\r\n    width: 100%;\r\n    border-radius: 0;\r\n  }\r\n}\r\n\r\n.top-round-border{\r\n  border-radius: 4px 4px 0 0;\r\n}\r\n\r\n.down-arrow-settings-dropdown {\r\n  position: absolute;\r\n  color: white;\r\n  display: flex;\r\n  height: 100%;\r\n  right: 26px;\r\n  top: 0px;\r\n  &:after {\r\n    content: \"\\f107\";\r\n    position: absolute;\r\n    display: flex;\r\n    font-family: \"Font Awesome 7 Free\", sans-serif;\r\n    font-weight: 900;\r\n    height: 100%;\r\n    font-size: 2.5rem;\r\n    align-self: center;\r\n  }\r\n}\r\n\r\n.up-arrow-settings-dropdown {\r\n  position: absolute;\r\n  color: white;\r\n  display: flex;\r\n  height: 100%;\r\n  right: 26px;\r\n  top: 0px;\r\n  &:after{\r\n    content: \"\\f106\";\r\n    position: absolute;\r\n    display: flex;\r\n    font-family: \"Font Awesome 7 Free\", sans-serif;\r\n    font-weight: 900;\r\n    height: 100%;\r\n    font-size: 2.5rem;\r\n    align-self: center;\r\n  }\r\n}\r\n.online-directory{\r\n  text-align: left;\r\n  font-size: 2.8rem;\r\n  & > li {\r\n    &, a, span {\r\n      text-transform: capitalize;\r\n    }\r\n  }\r\n}\r\n\r\n.edit-icon {\r\n  position: absolute;\r\n  right: 0px;\r\n  top: 0px;\r\n  height: 40px;\r\n  width: 40px;\r\n  padding: 7px;\r\n  font-size: 2.4rem;\r\n  cursor: pointer;\r\n\r\n  .fa-lg {\r\n    padding: .3em 0;\r\n  }\r\n\r\n  i {\r\n    font-size: 2.4rem;\r\n    vertical-align: top;\r\n  }\r\n  // padding: 0;\r\n  // font-size: 2.5rem;\r\n  // border-radius: 3px;\r\n  // width: 40px;\r\n  // height: 40px;\r\n  // line-height: 40px;\r\n  // text-align: center;\r\n}\r\n\r\n.editable-description {\r\n  position: relative;\r\n  word-break: break-word;\r\n}\r\n\r\n.profile-header {\r\n  margin-top: 1rem;\r\n  margin-bottom: 0.5rem;\r\n  width: 36.4rem;\r\n  padding: 1rem;\r\n  float: left;\r\n  label{\r\n    display: block;\r\n    padding-bottom: 1rem;\r\n    font-size: 1.8rem;\r\n    line-height: normal;\r\n    text-transform: none;\r\n  }\r\n}\r\n//show more less\r\n.show-more-less {\r\n\r\n\r\n  input[type='checkbox'] {\r\n    display: none;\r\n  }\r\n  .content {\r\n    overflow: hidden;\r\n    max-height: 100px;\r\n    position: relative;\r\n    line-height: 2rem;\r\n    word-break: break-word;\r\n  }\r\n\r\n  label {\r\n    background: #FFFFFF;\r\n    text-transform: lowercase;\r\n  }\r\n\r\n  label#show_more {\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    position: absolute;\r\n    top: 80px;\r\n    right:0px;\r\n    left: 0px;\r\n  }\r\n\r\n  label#show_less {\r\n    display: block;\r\n    cursor: pointer;\r\n    position: absolute;\r\n    top: 100%;\r\n    right:0px;\r\n    left: 0px;\r\n  }\r\n\r\n  input[type='checkbox'] ~ .content label#show_more {\r\n    display: block;\r\n  }\r\n\r\n  input[type='checkbox'] ~ .content label#show_less {\r\n    display: none;\r\n  }\r\n\r\n  input[type='checkbox']:checked ~ .content label#show_more {\r\n    display: none;\r\n  }\r\n\r\n  input[type='checkbox']:checked ~ .content label#show_less {\r\n    display: block;\r\n  }\r\n\r\n  input[type='checkbox']:checked ~ .content {\r\n    max-height: initial;\r\n    overflow:visible;\r\n  }\r\n}\r\n\r\n//three-line-overflow\r\n.block-with-text {\r\n  overflow: hidden;\r\n  position: relative;\r\n  line-height: 1.2em;\r\n  max-height: 3.6em;\r\n  text-align: justify;\r\n  margin-right: -1em;\r\n  padding-right: 1em;\r\n\r\n  &:before {\r\n    content: '...';\r\n    position: absolute;\r\n    right: 0;\r\n    bottom: 0;\r\n  }\r\n  &:after {\r\n    content: '';\r\n    position: absolute;\r\n    right: 0;\r\n    width: 1em;\r\n    height: 1em;\r\n    margin-top: 0.2em;\r\n    background: white;\r\n  }\r\n}\r\n\r\n.logged-in-user-spinner {\r\n  padding: 5px;\r\n  max-width: 50%;\r\n}\r\n\r\n.participant-contact-form {\r\n  position: relative;\r\n  padding: 1.5rem;\r\n\r\n  & > .form-row {\r\n    margin: 2.5rem 0px;\r\n\r\n    & > label {\r\n      margin: 5px 0px;\r\n    }\r\n\r\n    .icon-container {\r\n      padding: 5px 0px;\r\n\r\n      svg, label {\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n      }\r\n\r\n      label {\r\n        margin-left: 8px;\r\n      }\r\n    }\r\n\r\n    input {\r\n      width: 100%;\r\n    }\r\n  }\r\n}\r\n\r\n.stand {\r\n  display: inline;\r\n\r\n  .fa, .fa-solid, .fa-regular, .fa-light, .fa-brands {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  span {\r\n    margin-right: 5px;\r\n  }\r\n\r\n  .stand-name:not(:last-child) {\r\n    &:after {\r\n\t\t\tcontent:\",\";\r\n\t\t}\r\n  }\r\n}\r\n\r\n.search-bar {\r\n  .darkBorder();\r\n\r\n  .input-container {\r\n    margin-right: 67px;\r\n\r\n    input {\r\n      width: 100%;\r\n      display: block;\r\n      border: none;\r\n      padding: 9px 10px;\r\n    }\r\n  }\r\n\r\n  button {\r\n    float: right;\r\n    margin: 0px;\r\n\r\n    i {\r\n      font-size: 2.5rem;\r\n    }\r\n  }\r\n}\r\n\r\n.profile-image .image-container {\r\n  position: relative;\r\n  width: @participantProfileImageSize;\r\n  height: @participantProfileImageSize;\r\n  background: @defaultProfileImageBg;\r\n  border-radius: @participantProfileImageSize;\r\n  overflow: hidden;\r\n\r\n  img {\r\n    .absolute-vertical-center();\r\n  }\r\n}\r\n\r\n//switch\r\n\r\n.switch {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 140px;\r\n  height: 34px;\r\n\r\n  input {\r\n    opacity: 0;\r\n    width: 0;\r\n    height: 0;\r\n  }\r\n\r\n  input:checked+.slider {\r\n    background-color: #2196F3;\r\n\r\n    &:before {\r\n      margin-left: calc(100% - 36px);\r\n    }\r\n\r\n    .message {\r\n      left: 10px;\r\n      right: auto;\r\n      color: white;\r\n    }\r\n  }\r\n\r\n  input:focus+.slider {\r\n    box-shadow: 0 0 1px #2196F3;\r\n  }\r\n\r\n  .slider {\r\n    z-index: 1;\r\n    position: absolute;\r\n    cursor: pointer;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: #ccc;\r\n    -webkit-transition: .4s;\r\n    transition: .4s;\r\n    width: 140px;\r\n\r\n    .message {\r\n      position: absolute;\r\n      top: 5px;\r\n      left: 36px;\r\n      right: auto;\r\n    }\r\n\r\n    /* Rounded sliders */\r\n    &.round {\r\n      border-radius: 34px;\r\n    }\r\n\r\n    &.round:before {\r\n      border-radius: 50%;\r\n    }\r\n\r\n    &:before {\r\n      position: absolute;\r\n      content: \"\";\r\n      height: 26px;\r\n      width: 26px;\r\n      left: 4px;\r\n      bottom: 4px;\r\n      background-color: white;\r\n      -webkit-transition: .4s;\r\n      transition: .4s;\r\n    }\r\n  }\r\n}\r\n\r\n.image-help-text {\r\n  margin: auto;\r\n  margin-top: 43px;\r\n  margin-left: 19px;\r\n  font-size: 1.2rem;\r\n  color: @greyFontColor;\r\n\r\n  .icon-container {\r\n    span, i {\r\n      .verticalMiddle();\r\n    }\r\n\r\n    i.fa, i.fa-solid, i.fa-regular, i.fa-light, i.fa-brands {\r\n      font-size: 24pt;\r\n      margin-bottom: .5rem;\r\n      position: static;\r\n      width: auto;\r\n      color: @participantProfileColor;\r\n    }\r\n\r\n    span {\r\n      width: calc(100% - 40px);\r\n      margin-left: .5rem;\r\n      color: @participantProfileColor;\r\n      font-weight: 700;\r\n      font-size: 1.5rem;\r\n    }\r\n  }\r\n}\r\n\r\n.empty-content {\r\n  min-height: 10rem;\r\n  border: dashed thin #404040;\r\n  padding: 10px;\r\n  margin-top: 4rem;\r\n}\r\n\r\n.form-field-switch-group {\r\n  margin-bottom: 20px;\r\n}\r\n","@import './constants.less';\n@import './mixins.less';\n\n@spinner-size-big: 80px;\n\n.spinner-wrapper {\n  position: absolute;\n  width: 22px;\n  height: 22px;\n  top: 50%;\n  left: 50%;\n  margin-top: -11px;\n  margin-left: -11px;\n}\n\n.spinner-wrapper_big {\n  width: @spinner-size-big;\n  height: @spinner-size-big;\n  top: 50%;\n  left: 50%;\n  margin-top: -@spinner-size-big / 2;\n  margin-left: -@spinner-size-big / 2;\n\n  .circle-wrapper {\n    width: @spinner-size-big;\n    height: @spinner-size-big;\n  }\n}\n\n.spinner-wrapper_fixed {\n  position: fixed;\n}\n\n.circle-wrapper {\n  width: 22px;\n  height: 22px;\n  position: relative;\n}\n\n.circle {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.circle:before {\n  content: '';\n  display: block;\n  margin: 0 auto;\n  width: 20%;\n  height: 20%;\n\n  border-radius: 100%;\n  -webkit-animation: bouncedelay 1.2s infinite ease-in-out;\n  animation: bouncedelay 1.2s infinite ease-in-out;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n.circle2 {\n  -webkit-transform: rotate(30deg);\n  transform: rotate(30deg)\n}\n\n.circle3 {\n  -webkit-transform: rotate(60deg);\n  transform: rotate(60deg)\n}\n\n.circle4 {\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg)\n}\n\n.circle5 {\n  -webkit-transform: rotate(120deg);\n  transform: rotate(120deg)\n}\n\n.circle6 {\n  -webkit-transform: rotate(150deg);\n  transform: rotate(150deg)\n}\n\n.circle7 {\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg)\n}\n\n.circle8 {\n  -webkit-transform: rotate(210deg);\n  transform: rotate(210deg)\n}\n\n.circle9 {\n  -webkit-transform: rotate(240deg);\n  transform: rotate(240deg)\n}\n\n.circle10 {\n  -webkit-transform: rotate(270deg);\n  transform: rotate(270deg)\n}\n\n.circle11 {\n  -webkit-transform: rotate(300deg);\n  transform: rotate(300deg)\n}\n\n.circle12 {\n  -webkit-transform: rotate(330deg);\n  transform: rotate(330deg)\n}\n\n.circle2:before {\n  -webkit-animation-delay: -1.1s;\n  animation-delay: -1.1s\n}\n\n.circle3:before {\n  -webkit-animation-delay: -1.0s;\n  animation-delay: -1.0s\n}\n\n.circle4:before {\n  -webkit-animation-delay: -0.9s;\n  animation-delay: -0.9s\n}\n\n.circle5:before {\n  -webkit-animation-delay: -0.8s;\n  animation-delay: -0.8s\n}\n\n.circle6:before {\n  -webkit-animation-delay: -0.7s;\n  animation-delay: -0.7s\n}\n\n.circle7:before {\n  -webkit-animation-delay: -0.6s;\n  animation-delay: -0.6s\n}\n\n.circle8:before {\n  -webkit-animation-delay: -0.5s;\n  animation-delay: -0.5s\n}\n\n.circle9:before {\n  -webkit-animation-delay: -0.4s;\n  animation-delay: -0.4s\n}\n\n.circle10:before {\n  -webkit-animation-delay: -0.3s;\n  animation-delay: -0.3s\n}\n\n.circle11:before {\n  -webkit-animation-delay: -0.2s;\n  animation-delay: -0.2s\n}\n\n.circle12:before {\n  -webkit-animation-delay: -0.1s;\n  animation-delay: -0.1s\n}\n\n@-webkit-keyframes bouncedelay {\n  0%, 80%, 100% {\n    -webkit-transform: scale(0.0)\n  }\n  40% {\n    -webkit-transform: scale(1.0)\n  }\n}\n\n@keyframes bouncedelay {\n  0%, 80%, 100% {\n    -webkit-transform: scale(0.0);\n    transform: scale(0.0);\n  }\n  40% {\n    -webkit-transform: scale(1.0);\n    transform: scale(1.0);\n  }\n}\n\n\n.spinner {\n  width: 100%;\n  height: auto;\n  padding: 10px;\n  margin: auto;\n  text-align: center;\n  margin-bottom: 20px;\n  background: @spinnerBg;\n  .darkBorder();\n\n  .circle-wrapper,\n  .spinner-wrapper {\n    width: @smallSpinnerSize;\n    height: @smallSpinnerSize;\n    text-align: left;\n    .verticalMiddle();\n  }\n\n  .spinner-wrapper {\n    position: relative;\n    left: auto;\n    top: auto;\n    margin: 0px 10px 0px 0px;\n  }\n\n  &.big-spinner {\n    width: 200px;\n\n    .circle-wrapper,\n    .spinner-wrapper {\n        width: @bigSpinnerSize;\n        height: @bigSpinnerSize;\n        display: block;\n        margin: auto;\n    }\n  }\n}",".hierachical-filter {\n  .darkBorder();\n  border-radius: 0px;\n\n  & > ul > li {\n    & > .header {\n      .darkBorderBottom();\n      border-radius: 0px;\n    }\n    &:last-child > .header:not(.highlight) {\n      border-bottom: none;\n    }\n  }\n\n  ul > li {\n\n    .highlight {\n      .darkBorderBottom();\n      border-radius: 0px;\n    }\n\n    &.is-opened {\n      .darkBorderBottom();\n      border-radius: 0px;\n\n      .header:not(.highlight) {\n        border-bottom: none;\n      }\n    }\n\n    &.current-selected,\n    &.is-opened {\n      & > .header:after {\n        content: \"\";\n        width: 20px;\n        height: 20px;\n        background: lightcoral;\n        position: absolute;\n        right: 20px;\n        top: 20px;\n      }\n    }\n  }\n\n  ul {\n\n    li {\n      .header {\n        position: relative;\n        padding: 13px 20px;\n        cursor: pointer;\n\n        &.highlight {\n          position: relative;\n          padding: 5px 20px;\n\n          .highlighter {\n            position: absolute;\n            left: 0px;\n            top: 0px;\n            bottom: 0px;\n            width: 8px;\n          }\n        }\n      }\n      \n\n      &.multiselectable,\n      .multiselectable {\n        position: relative;\n        padding: 5px 20px;\n        margin-left: 20px;\n\n        &, input, label, .duplicate-checkbox {\n          cursor: pointer;\n        }\n        \n\n        input[type='checkbox'] {\n          display: none;\n        }\n\n        label {\n          position: relative;\n          padding-left: 20px;\n          z-index: 1;\n          font-size: 1.8rem;\n          font-weight: 400;\n          line-height: 1.8rem;\n          color: #4a4a4a;\n        }\n\n        .duplicate-checkbox {\n          content: \" \";\n          position: absolute;\n          left: 0px;\n          top: 4px;\n          .darkBorder();\n          padding: 12px;\n          border-radius: 0px;\n          margin-right: 20px;\n          z-index: 0;\n        }\n      }\n\n      //font\n      .header {\n        color: #2d2d2d;\n        font-style: normal;\n        font-stretch: normal;\n        line-height: normal;\n        letter-spacing: normal;\n\n        .category-name {\n          font-size: 1.8rem;\n          font-weight: bold;\n        }\n        .selected-items {\n          font-size: 1.3rem;\n        }\n      }\n    }\n  }\n}",".xplore-feedback {\n    right: 0;\n    bottom: 188px;\n    transform-origin: bottom right;\n    transform: rotate(-90deg);\n    display: block;\n    padding: 0;\n    position: fixed !important;\n    z-index: 9998;\n}\n\n.xplore-feedback-button {\n    font-size: 14px;\n    display: inline-block;\n    font-weight: bold;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.43;\n    padding: 10px 20px;\n    letter-spacing: normal;\n    width: fit-content;\n    height: fit-content;\n    white-space: nowrap;\n    background-color: #2f363f;\n    margin-bottom: 0;\n}\n",".survey-feedback-container {\n    display: block;\n    position: fixed;\n    left: 0;\n    top: 0;\n    z-index: 9999;\n    width: 100%;\n    height: 100%;\n    background-color: black;\n    background-color: rgba(0, 0, 0, 0.8);\n    -webkit-transition: 0.5s;\n    transition: all 0.3s linear;\n    -webkit-backdrop-filter: blur(2px);\n    backdrop-filter: blur(2px);\n}\n\n.survey-feedback-content {\n    padding: 12px;\n    margin-top: 108px;\n    border-radius: 6px;\n    background: white;\n    z-index: 1;\n    margin-left: auto;\n    margin-right: auto;\n    width: 80%;\n    height: 70%;\n    position: relative;\n    top: 10%\n}\n\n.survey-feedback-close{\n    float: right;\n    cursor: pointer;\n    text-align: center;\n    height: 44px;\n    width: 44px;\n}\n\n.survey-feedback-close-icon{\n    font-size: 28px;\n    color: grey;\n}\n\n.survey-loading-circle{\n    top: 50%;\n    left: 50%;\n    z-index: 999;\n    transform: translate(-50%, -50%);\n    position: absolute;\n}\n\n.survey-spinner-container {\n    background: none;\n    border: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
